jQuery.noConflict();
(function( $ ) {
	//jQuery.noConflict();

	//(function( $ ) {

		

	// ================

	// L A Z Y L O A D

	// ================

	

	// include plugins/jquery.lazyload.placeholder.js

	

	//$.lazyLoadXT.autoInit=false;

	

	$.extend($.lazyLoadXT, {

		//autoInit: false,

		//visibleOnly: false,

		//autoInit: false,

		oninit: {addClass: 'lazy'},

		onload: {removeClass: 'lazy', addClass: 'lazy-loaded'}

	});

	

	var options = $.lazyLoadXT,

		bgAttr = options.bgAttr || 'data-bg';

	

		options.selector += ',[' + bgAttr + ']';

	

		$(document).on('lazyshow', function (e) {

			var $this = $(e.target);

	

			if(!$this.data('lazyshow')){

				$this.data('lazyshow', true);

	

				//console.log('lazyshow');

				//console.log($this);

	

				// BACKGROUND

	

				if ($this.is("["+bgAttr+"]")) {

					$this

						.css('background-image', "url('" + $this.attr(bgAttr) + "')")

						.removeAttr(bgAttr);

				}

			}

		});

	

		$(document).on('lazyload', function (e) {

			var $this = $(e.target);

	

		});

	//})(jQuery);
	function navMain($el) {
		this.$nav_main 				= $el;
		this.$nav_main_ul			= $('> ul', this.$nav_main);
		this.$nav_main_active		= $('> li.active', this.$nav_main_ul);
		this.$nav_main_open			= $('> li.open', this.$nav_main_ul);
		this.$nav_sub 				= $('.nav-main__sub-nav', this.$nav_main);
		this.$wrapper				= $('.site-wrapper');
		this.$site					= $('.site-main');
		this.$html					= $('html');
		this.touch					= $('html.touch').length;
		this.timer					;
	
		this.pointerStartPosX		= 0;
		this.pointerStartDirX		= 0;
		this.pointerStartDirY		= 0;
		this.posX					= 0;
		this.dirX					= 0;
		this.dirY					= 0;
		this.moving					= false;
	};
	navMain.prototype = {
		constructor: navMain,
	
		initView: function(){
			this.$nav_main_ul.append($('.nav-meta li.nav-meta--blue, .nav-meta li.nav-meta--red').clone().addClass('mobile'));
	
		},
		initPlugins: function(){
		},
		initListeners: function(){
			var that = this;
			
			this.$nav_main.on('click', this.onClick.bind(this));
			this.$site.on('click', this.onClick.bind(this));
			$('li', this.$nav_sub).on('click', this.onClick.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				//if(that.$html.hasClass('nav--show')) that.$wrapper.css('height', $(window).height());
				
				// RESET FOR DESKTOP
				if(that.$nav_main_ul.css('position') == 'static' && that.$html.hasClass('nav--show')){
					that.$html.removeClass('nav--show level-0 level-1 level-2');
					$('ul, li', that.$nav_main).removeClass('opened');
					that.$wrapper.removeAttr('style');
				}
				
			});
			if(this.touch){
				$(window).bind('scroll',function(){
					that.navClose();
				});
			}
	
			this.$nav_main_ul.on('touchstart', this.onTouchStart.bind(this));
			this.$nav_main_ul.on('touchmove', this.onTouchMove.bind(this));
			this.$nav_main_ul.on('touchend', this.onTouchEnd.bind(this));
		},
		onTouchStart: function(e){
			var x = this.$nav_main_ul.offset().left;
			var w = this.$nav_main_ul.outerWidth();
	
			this.pointerStartDirX = this.getPointerEvent(e).pageX;
			this.pointerStartDirY = this.getPointerEvent(e).pageY;
			this.pointerStartPosX = this.getPointerEvent(e).pageX-x;
		},
		onTouchMove: function(e){
			this.posX = this.getPointerEvent(e).pageX-this.pointerStartPosX;
			this.dirX = this.getPointerEvent(e).pageX-this.pointerStartDirX;
			this.dirY = this.getPointerEvent(e).pageY-this.pointerStartDirY;
	
			var x = Math.max(0, this.posX);
			var w = this.$nav_main_ul.outerWidth();
			var p = Math.max(0, Math.min(50, this.posX*100/w));
	
			if($('html.until-tabletLandscape').length){
				if(Math.abs(this.dirY) < 5 && !this.$nav_main_ul.hasClass('dragging')){
					this.moving = true;
				}
				if(this.moving){
					this.$nav_main_ul.css({transform: 'translateX('+p+'%)'});
					//this.$nav_main_ul.css({transform: 'translateX('+x+'px)'});
				}
				this.$nav_main_ul.addClass('dragging');
			}
		},
		onTouchEnd: function(e){
			if(this.moving){
				if(this.dirX > 0){
					this.navSlide();
				}
			}
			this.$nav_main_ul.removeAttr('style').removeClass('dragging');
			this.moving = false;
		},
		getPointerEvent: function(e) {
			return e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0] : e;
		},
		onClick: function(e){
			var that				= this;
			var $target				= $(e.target), $cTarget = $(e.currentTarget);
			var $a					= ($target.is('a') ? $target : ($target.is('span') ? $target.parent() : $target.closest('')));
			var $li					= $a.parent();
			var $ul					= $target.parent().parent().closest('ul');
			var subs				= $('ul', $li).length;
			var level				= $a.parents('ul').length;
	
			this.$nav_main_open		= $('> li.open', this.$nav_main_ul);
	
			/*
			console.log($target);
			console.log($cTarget);
			console.log($a);
			console.log(subs);
			console.log(level);
			*/
	
			// CLOSE NAV
			if(this.$nav_main_ul.css('position') == 'static' && $target.hasClass('site-main') && this.$nav_main_open.length){
				this.navClose();
			}
	
			// MAIN NAV
			if(this.$nav_main_ul.css('position') == 'static' && ($target.parents('.site-header').length)){
				if(subs){
					e.stopPropagation();
					e.preventDefault();
	
					if(this.$nav_main_open.length && this.$nav_main_open[0] == $li[0]){
						this.navClose();
					}else{
						if(this.$nav_main_open.length) this.$html.addClass('nav-open-already');
						this.$nav_main_open.removeClass('open');
						$li.addClass('open');
						this.$html.addClass('nav-open');
					}
				}
			}
	
			// MOBILE NAV
			if(this.$nav_main_ul.css('position') != 'static' && ($target.parents('.site-header').length || $target.hasClass('site-main'))){
				e.stopPropagation();
	
				if($target.parents('.nav-service').length || $target.parent().hasClass('logo')){
				}else if(!$('ul', $target.parent().parent()).length){
				//}else if(!subs && $target.is('a')){
				}else if($target.is('a')){
				}else{
					e.stopPropagation();
					e.preventDefault();
					
					this.$html.addClass('level-'+level);
					if(!this.$html.hasClass('nav--show')){
						this.$wrapper.css('height', $(window).height());
					}
					
					clearTimeout(this.timer);
					this.timer = setTimeout(function(){
						that.$wrapper.css('height', $('.nav-main > ul').innerHeight());
					}, 500);
					
					if(subs){
						var isOpen = $li.hasClass('opened');
						$target.parent().closest('li').toggleClass('opened');
						$ul.toggleClass('opened');
						if(!$ul.hasClass('opened')){
							this.$html.removeClass('level-'+level+' level-'+(level+1));
							$('ul, li', $ul).removeClass('opened');
	
							if(isOpen){
								console.log('opened');
							}else{
								$ul.toggleClass('opened');
								$target.parent().closest('li').toggleClass('opened');
								this.$html.addClass('level-'+level);
							}
						}else{
						}
					}else if($target.is('ul')){
						$target.removeClass('opened');
						$('> li',$target).removeClass('opened');
					}else if($cTarget.hasClass('nav-main') || (($cTarget.hasClass('site-wrapper') || $cTarget.hasClass('site-main')) && this.$html.hasClass('nav--show'))){
						this.navSlide();
					}
				}
			}else if(this.touch && $('.nav-main__sub-nav', $li).length){
				e.stopPropagation();
				e.preventDefault();
				this.$nav_main_ul.addClass('show');
				$('>li', this.$nav_main_ul).removeClass('show');
				$li.addClass('show');
			}else if($target.not('a').length && $target.parents('.nav-main__sub-nav').length){
				e.stopPropagation();
				var a = $('a:first-child', $target);
				location.href = a.attr('href');
			}else if($cTarget.hasClass('site-wrapper')){
				this.navClose();
			}
		},
		navSlide: function(){
			var that = this;
			this.$html.toggleClass('nav--show');
			$('ul, li', this.$nav_main).removeClass('opened');
			
			if(!this.$html.hasClass('nav--show')){
				this.$html.removeClass('level-0 level-1 level-2');
				
				clearTimeout(this.timer);
				this.timer = setTimeout(function(){
					that.$wrapper.removeAttr('style');
				}, 500);
			}
		},
		navClose: function(){
			if(this.$nav_main_open.length){
				this.$nav_main_open.removeClass('open');
				this.$html.removeClass('nav-open nav-open-already');
			}
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function navSub($el) {
		this.$el				= $el;
		this.$nav_back			= $('.nav-sub__back', this.$el);
		this.$nav				= $('.nav-sub__nav', this.$el);
		this.$li				= $('li', this.$nav);
		this.$a					= $('a', this.$li);
		this.$share				= $('li.share a', this.$el);
		this.$select			= $('<select class="js-nav-sub-select"></select>');
	};
	navSub.prototype = {
		constructor: navSub,
	
		initView: function(){
			var that = this;
	
			if(!$('li.active', this.$nav).length) $('li:eq(0)', this.$nav).addClass('selected');
	
			$('li', this.$nav).each(function(){
				var $li = $(this), $a = $('> a', $li);
				that.$select.append($('<option value="'+$a.attr('href')+'" '+($li.hasClass('active') ? 'selected="selected"' : '')+'>'+$a.text()+'</option>'))
			});
			this.$nav.append(this.$select);
		},
		initPlugins: function(){
			//this.$el.stick_in_parent({
				//parent: ".site-main"
			//});
			this.$el.fixTo('body', {useNativeSticky: false, className: 'is_stuck'});
		},
		initListeners: function(){
			this.$a.on('click', this.onClickNav.bind(this));
			this.$select.on('change', this.onChange.bind(this));
			this.$share.on('click', this.onClickShare.bind(this));
			this.$nav_back.on('click', this.onClickBack.bind(this));
		},
		onChange: function(e){
			var $option = $('option:selected', this.$select), index = $option.index(), href = $option.val();
	
			this.$li.removeClass('active selected').filter(':eq('+index+')').addClass('active');
	
			if(!this.$el.hasClass('js-nav-sub-dynamic')){
				this.setLink(href);
			}
		},
		setLink: function(href){
			if(href.indexOf('#')>=0){
				console.log(href);
				if($(href).length) TweenMax.to(window, 0.75, {scrollTo: {y: $(href).offset().top-this.$el.outerHeight(), autoKill: true}, ease: Quart.easeInOut, onComplete:function(){
					//location.hash = href;
				}});
			}else{
				//location = href;
			}
		},
		onClickNav: function(e){
			var $target = $(e.currentTarget), href = $target.attr('href');
			if(href.indexOf('#') >= 0){
				e.stopPropagation();
				e.preventDefault();
			}
			this.setLink(href);
		},
		onClickBack: function(e){
			var $target = $(e.target);
			if(!$target.is('a')){
				location = $('a', $target).attr('href');
			}
		},
		onClickShare: function(e){
			var $target = $(e.currentTarget).parent();
			e.preventDefault();
	
			console.log($target);
			$target.toggleClass('hover');
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	
	function navFooter($el) {
		this.$el 				= $el;
		this.$up				= $('.page-up', this.$el);
	};
	navFooter.prototype = {
		constructor: navFooter,
	
		initView: function(){
			var that = this;
	
			/*if(typeof scrollController !== 'undefined'){
				that.$nav_main.each(function (i, e) {
					new ScrollMagic.Scene({
						triggerElement: e,
						triggerHook: "onLeave",
						offset: "400px",
					})
					.setClassToggle(that.$up[0], 'up--show')
					.addTo(scrollController);
				});
			}
			*/
		},
		initPlugins: function(){
		},
		initListeners: function(){
			this.$up.on('click', this.onClickUp.bind(this));
		},
		onClickUp: function(e){
			TweenMax.to(window, 1, {scrollTo: {y:0, autoKill: true}, ease: Cubic.easeInOut});
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	function homeNews($el) {
		this.$el 					= $el;
		this.$news_container		= $('.teaser__body', this.$el);
		this.$news_wrapper			= $('> div', this.$news_container);
		this.$news_items			= $('> div', this.$news_wrapper);
		this.$news_bullets			= $('<div class="pagination pagination"></div>');
		this.$news_swiper			;
	};
	homeNews.prototype = {
		constructor: homeNews,
	
		initView: function(){
			var that = this;
	
			this.$news_container.addClass('swiper-container');
			this.$news_wrapper.addClass('swiper-wrapper');
			this.$news_items.addClass('swiper-slide');
			this.$news_container.parent().append(this.$news_bullets);
		},
		initPlugins: function(){
			var that = this;
	
			this.$news_swiper = new Swiper(this.$news_container, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$news_bullets,
				paginationClickable: 'true',
				slidesPerView: 1,
				slideActiveClass: 'active',
				//autoHeight: true,
	
				onInit: function(swiper){
				},
				onSlideChangeStart: function(swiper){
				},
				onSlideChangeEnd: function(swiper){
				}
			});
		},
		initListeners: function(){
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function homeFacebook($el) {
		this.$el 					= $el;
		this.$news_container		= this.$el;
		this.$news_wrapper			= $('> div', this.$news_container);
		this.$news_items			= $('> div.teaser__fb__item', this.$news_wrapper);
		this.$news_bullets			= $('<div class="pagination pagination"></div>');
		this.$news_swiper			;
	};
	homeFacebook.prototype = {
		constructor: homeFacebook,
	
		initView: function(){
			var that = this;
	
			this.$news_container.addClass('swiper-container');
			this.$news_wrapper.addClass('swiper-wrapper');
			this.$news_items.addClass('swiper-slide');
			this.$news_container.append(this.$news_bullets);
		},
		initPlugins: function(){
			var that = this;
	
			this.$news_swiper = new Swiper(this.$news_container, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$news_bullets,
				paginationClickable: 'true',
				slidesPerView: 1,
				slideActiveClass: 'active',
				//autoHeight: true,
	
				onInit: function(swiper){
				},
				onSlideChangeStart: function(swiper){
				},
				onSlideChangeEnd: function(swiper){
					$(window).trigger('resize');
				}
			});
		},
		swiperRemove: function(){
			this.$news_container.removeClass('swiper-container');
			this.$news_wrapper.removeClass('swiper-wrapper');
			this.$news_items.removeClass('swiper-slide');
			this.$news_items.removeClass('slide--hidden');
			$('.pagination', this.$news_container).remove();
			this.$news_swiper.destroy(false, true);
		},
		initListeners: function(){
			var that = this;
	
			 $(window).bind('resize orientationchange', function(){
			 	var swiper = Modernizr.mq('(max-width: '+breakPoints.tablet+'px)');
				
			 	if(swiper && !that.$news_wrapper.hasClass('swiper-wrapper')){
			 		that.initView();
			 		that.initPlugins();
			 	}else if(!swiper && that.$news_wrapper.hasClass('swiper-wrapper')){
			 		that.swiperRemove();
			 	}
			 });
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function eventsView($el) {
	    this.$events			= $el;
		this.$items				= $('.event', this.$events);
		this.$months			= $('.events__months', this.$events);
		this.$select			= $('<select></select>');
		this.$timer				;
		this.navYearTimer		;
	};
	eventsView.prototype = {
	    constructor: eventsView,
	
	    initView: function(){
	        var that = this;
			
			this.$items.removeClass('event--show');
			this.dots($('.event__text', this.$items));
			
			// TICKETS BUTTON
	        $('.button--tickets a', this.$events).each(function(){
				that.tickets($(this));
			});
			
			// MOBILE
			$('li > a', this.$months).each(function(){
				var $a = $(this), selected = ($a.parent().hasClass('active') ? " selected" : "");
				that.$select.append($('<option value="'+$a.attr('href')+'"'+selected+'>'+$a.attr('title')+'</option>'))
			});
			this.$months.prepend(this.$select);
			
			//$('p#yearPrev, p#yearNext').css('opacity',0.25);
			//$('p#yearPrev.active, p#yearNext.active').css('opacity',1);
			
			$('*[data-bg]', this.$events).lazyLoadXT();
			//$(window).trigger('resize');
	    },
	    initPlugins: function(){
			setTimeout(function(){
				$('.event--linked').each(function(){
					var $event = $(this);
	
					$('.event__more', $event).trigger('click');
					TweenMax.to(window, 1, {scrollTo: {y: $event.offset().top-30, autoKill: true}, ease: Cubic.easeInOut});
				});
			}, 500);
	    },
	    initListeners: function(){
	        $('.event__more, .event__close', this.$events).on('click', this.onClick.bind(this));
			$('p#yearPrev a, p#yearNext a', this.$el).on('click', this.navYear.bind(this));
			this.$select.on('change', this.onChange.bind(this));
			
			// VIDEOS
			//$("a[href*='youtu']", this.$events).prettyPhoto({/*show_title: false*/});
	    },
		dots: function($items) {
			$items.dotdotdot({ellipsis: '...', tolerance: 0, watch: true});
		},
		onChange: function(e){
			location = $('option:selected', this.$select).val();
		},
		navYear: function(e) {
			e.preventDefault();
			
			var $a = $(e.target);
			var url = 'http://www.jakobisaal.at/jakobisaal/programm/archiv/';
			var years = $a.parent().parent().attr('class').split('-');
			var year = parseInt($('#yearActive').text());
			
			year = $a.parent().attr('id') == 'yearPrev' ? year-1 : year+1;
			year = Math.min(parseInt(years[2]),Math.max(parseInt(years[0]),year));
			$('#yearActive').text(year);
			
			clearTimeout(this.navYearTimer);
			url = url+'jahr/'+year+'/';
			
			this.navYearTimer = setTimeout(function(){
				location.href = url;
			}, 1000);
		},
		tickets: function($a){
			$a.data('href', 'http://www.jakobisaal.at/index.php?id='+154+'&event_id='+$a.attr('class'));
			new popupView($a).init();
		},
	    onClick: function(e){
	        if($(e.target).hasClass('event__more')){
				this.expand($(e.target).parent().parent());
			}else{
				this.collapse($(e.target).parent());
			}
	    },
		expand: function($event){
			var that	= this;
			var $text	= $('.event__text', $event);
			var $active	= $('.event.event--show');
			var h		= $text.prop('scrollHeight');
			
			if($active.length) this.collapse($active);
			
			$text.trigger("destroy");		
			$text.css('height', h+'px');
			
			$event.addClass('event--show');
			
			setTimeout(function(){
				$text.css('height', $text.prop('scrollHeight')+'px');
				
				clearTimeout(that.$timer);
				that.timer = setTimeout(function(){
					$event.addClass('event--opened');
					$text.removeAttr('style');
				}, 1000);
			},20);
	
			// VIDEOS
			$("a[href*='youtu'], .custom-video-header", $text).each(function(){
				if($(this).hasClass('video-inline')){
					if($('html.no-touch').length){
						new videoView($(this)).init();
					}else{
						$('.custom-video-header__overlay__inner', $(this)).addClass('open');
					}
				} else {
					var videoId = $(this).attr('href').match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/);
					
					if(videoId){
						new videoView($(this)).init();
					}			
				}
			});
		},
		collapse: function($event){
			var that	= this;
			var $text	= $('.event__text', $event);
			
			$text.css('height', $text.prop('scrollHeight')+'px');
			
			clearTimeout(this.$timer);
			this.$timer = setTimeout(function(){
				$event.removeClass('event--opened');
				$event.removeClass('event--show');
				$text.removeAttr('style');
				setTimeout(function(){
					that.dots($text);
				}, 500);
			}, 10);
		},
	    init: function(){
	        this.initView();
	        this.initListeners();
	        this.initPlugins();
	    }
	
	}
	
	function popupView($el) {
	
		if (typeof $el === "object") {
			this.$btn			= $el;
			this.href			= $el.data('href') ? $el.data('href') : this.$btn.attr('href');
		};
	
		this.$popup				;
		this.$popupInner		;
		this.$overlay			= $('<div class="popup-overlay"></div>');
		this.$close;
		this.$site				= $('.site-wrapper');
		this.$siteHeader		= $('.site-header');
		this.$html				= $('html');
		
		if (typeof $el === "string") {
			this.openContent($el);
		};
	};
	popupView.prototype = {
		constructor: popupView,
	
		initView: function(){
		},
		initPlugins: function(){
		},
		initListeners: function(){
			this.$btn.on('click', this.onClick.bind(this)).addClass('initialized');
			this.$overlay.on('click', this.onClick.bind(this));
		},
		popupLoad: function(url){
			var that = this;
			
			if(!$('.popup-overlay').length) {
				$('body').append(that.$overlay);
				
				setTimeout(function(){
					$('.popup-overlay').addClass('show');
				},0);
			}
			
			if(that.href.indexOf('#')>=0){
				that.$popup = $(that.href);
				that.popupCreate();
				that.popupOpen();
			}else if(url || (!that.$popup && that.href != '#')){	
				jQuery.ajax({
					context: this,
					url: url || that.href,
					type: "POST",
					//data: data,
					cache: false
				})
				.done(that.contentLoaded);
			}
		},
	
		openContent: function(content){
			this.contentLoaded(content);
		},
	
		contentLoaded: function(response){
			var that = this;
			var $content = $(response);
	
			if ($content.hasClass('popup-outer')) {
				that.$popup = $content;
			}
			else {
				that.$popup = $('.popup-outer', $content);
			};
	
			if (!that.$popup.length) {
				console.error('Popup not found in server response.');
				return;
			};
	
			that.$popup.removeClass('show');
			that.popupCreate();
			that.popupOpen();
		},
	
		popupCreate: function(){
			var that = this;
			
			$('body').append(that.$popup);
	
			that.$popupInner = $('.popup-inner', that.$popup);
			that.$close = $('.popup-close', that.$popup);
	
			//that.$overlay.on('click', that.onClick.bind(that));
			that.$close.on('click', that.onClick.bind(that));
	
			that.$popup.data('popupView', {
				close: that.popupClose.bind(that)
			});
	
			// LAZYLOAD
			$('*[data-bg], *[data-src]', this.$popup).lazyLoadXT();
			
			// INPUT
			$('input[type=radio], input[type=checkbox]', this.$popup).each(function(){
	            new inputView($(this)).init();
			});
			
			// SELECT
			$('.select-box', this.$popup).each(function(){
				//new selectBox($(this)).init();
			});
			
			//TICKETS
			$('#fTickets', this.$popup).each(function(){
				new ticketsView($(this)).init();
			});
			
			// EMAIL
			$('a[href*="javascript:linkTo"]', this.$popup).each(function(){
	            new emailView($(this)).init();
	        });
	
		},
		popupOpen: function(){
			if(!this.$popup.hasClass('show')){
				var yDiff;
				
				if(typeof scrollController !== 'undefined'){
					scrollController.enabled(false);
				}
				
				this.$html.data('scrollTop', $(window).scrollTop());
				this.$site.css('top', -this.$html.data('scrollTop'));
				this.$html.addClass('popup-show');
				
				//yDiff = 50;
				
				//this.$popupInner.css('margin-top', yDiff);
				
				this.$popup.show();
				//this.$overlay.show();
				this.$popupInner.show();
				this.$popup.addClass('show');
				
				$('html, body').scrollTop(0);
			}
		},
		popupClose: function(){
			var that = this;
			
			if($('.popup-overlay.show').length) {
				$('.popup-overlay').removeClass('show');
				setTimeout(function(){
					$('.popup-overlay').detach();
				},500);
			}
			
			if(this.$popup && this.$popup.hasClass('show')){
				this.$popup.removeClass('show');
				setTimeout(function(){
					that.$popup.hide();
					that.$popup.remove();
					that.$popup = false;
				}, 1000);
				
				if(typeof scrollController !== 'undefined'){
					scrollController.enabled(true);
					scrollController.update(true);
				}
				
				this.$site.css('top','auto');
				this.$html.removeClass('popup-show');
				this.$siteHeader.css('margin-bottom', 'auto');
				
				$('html, body').scrollTop(this.$html.data('scrollTop'));
			}
		},
	
		onClick: function(e){
			e.preventDefault();
			
			var that = this;
			var $clicked = jQuery(e.currentTarget);
			var $popup = $clicked.closest('.popup-outer');
			/*
			var data = $clicked.data();
	
			if (data.template) {
				that.openTemplate(data.template);
				return;
			};
			*/
	
			if(!$('.popup-overlay.show').length) {
				that.popupLoad();
			}else{
				$clicked.hasClass('popup') ? that.popupOpen() : that.popupClose();
			}
		},
	
		openTemplate: function(selector){
			// Add dot and remove dot if present
			selector = '.' + selector.replace(/\./, '');
	
			var $template = jQuery(selector);
	
			if (!$template.length) {
				console.error('Template not found');
				return;
			};
	
			this.openContent($template.html());
	
		},
	
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	window.popupView = popupView;
	function videoView($el) {
		this.$el 				= $el;
		
		this.videoPlayer		;
		this.innerVid			= this.$el.hasClass('video-inline');
		this.playerId			= this.innerVid ? 'cvh-ytPlayer' : 'ytPlayer';
		this.playState			;
		
		window.youTubeAPIReady	;
		
		this.isBtn				= this.$el.is('a');
		this.hasBtn				= $('a', this.$el).length;
	
		this.videoId			= this.isBtn ? this.$el.attr('href').match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/) : this.$el.data('video-id');
		this.videoId			= this.videoId && typeof this.videoId === 'object' ? this.videoId.pop() : this.videoId;
	
		this.closing			;
			
		this.autoInit			= this.$el.hasClass('video--init-onload');
		this.$popup;
		this.$popupInner;
		this.$overlay 			= $('<div class="video-overlay"></div>');
		this.$close				= $('<div class="video-close"></div>');
		this.$tpl				= $('<article class="video-outer" style="display: none;">\
										<div class="video-overlay"></div>\
										<div class="video__wrapper">\
											<div class="video__inner">\
												<div class="video__body">\
													<div id="ytPlayer"></div>\
												</div>\
											</div>\
										</div>\
										<div class="video-close"></div>\
									</article>');
	};
	
	videoView.prototype = {
	    constructor: videoView,
	
	    initView: function(){
	    },
	    initPlugins: function(){
			if(!this.isBtn && this.videoId){
				this.videoPlayerPrepare();
				this.videoOpen();
			}
	    },
	    initListeners: function(){
			if(this.isBtn) this.$el.on('click', this.onClick.bind(this));
			if(this.hasBtn) this.$el.on('click', this.onClickInnerBtn.bind(this));
	    },
		onClick: function(e){
			e.preventDefault();
			
			if(this.videoId){
				var $clicked = $(e.currentTarget);
	
				if(this.isBtn && !$clicked.hasClass('video-close') && !$clicked.hasClass('video-overlay')){
					this.videoPlayerPrepare();
					this.videoOpen();
				}else{
					this.videoClose();
				}
			}
		},
		onClickInnerBtn: function(e){
			location.href = $('a', this.$el).attr('href');
		},
		
		videoOpen: function(content){
			var that = this;
			
			console.log('videoOpen');
			
			if(that.$popup && !that.$popup.hasClass('show')){
				that.$popup.show();
				
				setTimeout(function(){
					that.$popup.addClass('show');
				}, 0);
				
				setTimeout(function(){
					that.$popup.removeClass('stop');
				}, 600);
			}
				
			if(this.videoPlayer){
				console.log('this.videoPlayer loadVideoById');
				this.videoPlayer.loadVideoById(this.videoId);
			}else{
				clearInterval(that.closing);
				that.closing = setInterval(function(){
					if(window.youTubeAPIReady){
						clearInterval(that.closing);
						setTimeout(function(){
							that.videoPlayerInit();
						}, 500);
					}
				}, 30);
			}
		},
		
	    videoClose: function(){
			var that = this;
			
			console.log('videoClose');
			
			if(this.$popup.hasClass('show')){
				this.$popup.removeClass('show playing');
				
				clearInterval(that.closing);
				that.closing = setInterval(function(){
					if(that.videoPlayer){
						clearInterval(that.closing);
						that.videoPlayer.pauseVideo();
						
						setTimeout(function(){
							that.stopVideo();
							that.$popup.hide();
			
							console.log('videoClosed');
						}, 1000);
					}
				}, 30);
				
				if(typeof scrollController !== 'undefined'){
					scrollController.enabled(true);
					scrollController.update(true);
				}
			}
	    },
		
		videoPlayerPrepare: function(){
			
			console.log('videoPlayerPrepare');
			
			if(!window.onYouTubeIframeAPIReady){
				var tag = $('<script></script>');
				tag.attr('src','https://www.youtube.com/iframe_api');
				$('body').append(tag);
				
				window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;
			}
			
			if(!$('.video-outer').length){
				if(!this.innerVid) $('body').prepend(this.$tpl.clone());
			}
			
			if(!this.innerVid){
				this.$popup		= $('.video-outer');
				this.$close		= $('.video-close', this.$popup);
				this.$overlay	= $('.video-overlay', this.$popup);
	
				this.$close.on('click', this.onClick.bind(this));
				this.$overlay.on('click', this.onClick.bind(this));
			}else{
				$('.custom-video-header__overlay__inner').addClass('open');
			}
			
		},
		
		videoPlayerInit: function(){
			var $player = $('#'+this.playerId);
			
			if($player.length && $player.data('videoPlayer')){
				$player.data('videoPlayer').loadVideoById(this.videoId);
			}else if(!this.videoPlayer){
				this.videoPlayer = new YT.Player(this.playerId, {
					height: '100%',
					width: '100%',
					videoId: this.videoId,
					events: {
						'onReady': this.onYouTubePlayerReady.bind(this),
						'onStateChange': this.onYouTubePlayerStateChange.bind(this)
					},
					playerVars: {
						autohide: 1,
						autoplay: 1,
						enablejsapi: 1,
						controls: 2,
						color: 'red',
						modestbranding: 1,
						showinfo: 0,
						fs: 1,
						rel: 0,
						playsinline: 0
					}
				});
				
				$('#'+this.playerId).data('videoPlayer', this.videoPlayer);
			}
			
			//if(this.innerVid) window.videoPlayer.loadVideoById(this.videoId);
		},
		
		onYouTubeIframeAPIReady: function(){
			if(!window.youTubeAPIReady){
				window.youTubeAPIReady = true;
			}
		},
	
		onYouTubePlayerReady: function(event) {
			console.log('onYouTubePlayerReady');
			//event.target.playVideo();
			//event.target.loadVideoById(this.videoId);
		},
	
		onYouTubePlayerStateChange: function(event) {
			
			if (event.data == YT.PlayerState.PLAYING && this.playState != 'PLAYING') {
				console.log('VIDEO -- PLAYING');
				this.playState = 'PLAYING';
				if(this.$popup) this.$popup.addClass('playing');
				if(this.innerVid) $('.custom-video-header__overlay__inner').removeClass('open');
			}
			if (event.data == YT.PlayerState.BUFFERING && this.playState != 'BUFFERING') {
				console.log('VIDEO -- BUFFERING');
				this.playState = 'BUFFERING';
				if(this.$popup) this.$popup.addClass('buffering');
				if(this.innerVid) $('.custom-video-header__overlay__inner').removeClass('open');
			}
			if (event.data == YT.PlayerState.ENDED && this.playState != 'ENDED') {
				console.log('VIDEO -- ENDED');
				this.playState = 'ENDED';
				if(this.$popup) this.videoClose();
				if(this.innerVid) $('.custom-video-header__overlay__inner').addClass('open');
			}
		},
	
		stopVideo: function() {
			if(this.videoPlayer){
				this.videoPlayer.stopVideo();
				this.videoPlayer.clearVideo();
				//this.videoPlayer.destroy();
				this.$popup.addClass('stop');
			}
		},
				
	    init: function(){
	        if(!this.$el.data('videoView')){
				this.$el.data('videoView', this);
				this.initView();
	        	this.initListeners();
	        	this.initPlugins();
			}
	    }
	
	}
	
	
	
	function formView( $el ) {
		this.$body				= $el;
		this.$form				= $('.form', $el);
		this.$submit			= $('input.submit', this.$body);
		this.sending			= false;
	};
	formView.prototype = {
		constructor: formView,
		
		initView: function(){
		},
		initPlugins: function(){
		},
		initListeners: function (){
			this.$submit.on('click', this.onSubmit.bind(this));
		},
		onSubmit: function(e){
			var that = this;
			var vars = $(':input', this.$body).serialize();
			var errors = this.formErrors();
			
			console.log(vars);
			
			if(errors > 0){
				console.log('errors: '+errors);
			}else if(!this.sending){
				this.sending = true;
				jQuery.ajax({
					context: this,
					url: location.href,
					type: "POST",
					data: vars,
					dataType: 'json',
					cache: false,
					success: that.onResponse
				})
				.done(that.done);
			}
		},
		onResponse: function(data){
			console.log(data);
			if(data.error){
				alert(data.error);
			}else if(data.success){
				location = this.$form.data('success');
			}
		},
		done: function(){
			console.log('done');
			this.sending = false;
		},
		formErrors: function(){
			var err_str = "";
			
			$('.required', this.$body).each(function(i) {
				var $input = $(this);
				var n = $input.attr('name').toLowerCase();
				var v = $input.attr('type') == "checkbox" ? $input.is(':checked') : $input.val();
				var err = false;
				var emailReg = /^([A-Za-z0-9_\-\.\'])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
				
				$input.parent().removeClass('error');
				
				switch ($input.attr('type')) {
					case "email":
						err = !emailReg.test(v) ? true : false;
						break;
					default:
						err = v=='' || !v ? true : false;
						break;
				}
				if($input.is(':hidden')) err = false;
				if(err){
					$input.parent().addClass('error');
					err_str += "\n"+($input.attr('title') ? $input.attr('title') : $input.attr('name').split("_").join(" "));
				}
			});
			
			if(err_str != ""){
				alert("Bitte überprüfen Sie Ihre Daten:\n"+err_str);
			}
			
			return $('.error', this.$body).length;
		},
		validate: function(){
			var error;
			var error_str = "";
			var form = this.$form;
			var f = $(this).find('input.required, select.required, textarea.required').removeClass('error').inputValidate();
			
			f.each(function(i) {
				if($(this).data('validate').error){
					error = true;
					error_str += "\n"+($(this).attr('title') ? $(this).attr('title') : $(this).attr('name').split("_").join(" "));
					$(this).addClass('error');
				}
			});
					
			if(error){
				alert("Bitte überprüfen Sie Ihre Daten:\n"+error_str);
				return false;
			}else{
				return true;
			}
		},
		inputValidate: function() {
			return this.each(function(i) {
				var n = $(this).attr('name').toLowerCase();
				var v = $(this).attr('type') == "checkbox" ? $(this).is(':checked') : $(this).val();
				var err = false;
				var emailReg = /^([A-Za-z0-9_\-\.\'])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
				switch (n) {
					case "email":
					err = !emailReg.test(v) ? true : false;
					break;
				default:
					err = v=='' || !v ? true : false;
					break;
				}
				if($(this).is(':hidden')) err = false;
				$(this).data('validate',{error:err});
			});
		},
		init: function(){
					this.initView();
					this.initListeners();
					this.initPlugins();
		}
	
	}
	
	function inputView($el) {
		this.$el 				= $el;
		this.$parent			= this.$el.parent();
		this.name				= this.$el.attr('name');
		this.isRadio			= this.$el.attr('type') == 'radio';
		this.isCheckbox			= this.$el.attr('type') == 'checkbox';
	};
	inputView.prototype = {
	    constructor: inputView,
	
	    initView: function(){
			if(this.isRadio || this.isCheckbox){
				if(this.$el.prop('checked')){
					this.$parent.addClass('selected');
				}else{
					this.$parent.removeClass('selected');
				}
			}
	    },
	    initPlugins: function(){
	    },
	    initListeners: function(){
			if(this.isRadio || this.isCheckbox){
				this.$el.on('change', this.onClick.bind(this));
			}
	    },
		onClick: function(e){
			var that = this;
			var $div = that.$parent.parent().parent();
			
			if (this.$el.prop('checked')) {
				this.$parent.addClass('selected');
			} else {
				this.$parent.removeClass('selected');
			}
			
			if(this.isRadio){
				$('> p input[name="'+this.name+'"]', $div).each(function(){
					var $input = $(this), $label = $input.parent();
						
					if(that.$el != $input){
						if ($input.prop('checked')) {
							$label.addClass('selected');
						} else {
							$label.removeClass('selected');
						}
					}
				});
				
			}else if(this.isCheckbox){
				if(this.$parent.hasClass('select--all')){
					var $all = this.$el, all_selected = $all.parent().hasClass('selected');
					
					$('> p input[type=checkbox]', $div).each(function(){
						var $input = $(this), $label = $input.parent();
						
						if($all != $input){
							if(all_selected){
								$label.addClass('selected');
								$input.prop('checked', true);
							}else{
								$label.removeClass('selected');
								$input.prop('checked', false);
							}
						}
					});
				}else{
					$('> p .select--all', $div).removeClass('selected');
					$('> p .select--all input', $div).prop('checked', false);
				}
				
				if($('input[name="is_subscribed"]', $div.parent()).length) $('input[name="is_subscribed"]', $div.parent()).val($('label.selected', $div).length ? '1' : '0');
			}
		},
	    init: function(){
	        this.initView();
	        this.initListeners();
	        this.initPlugins();
	
	        this.$el.addClass('initialized');
	    }
	
	}
	function mapView($el) {
		this.$events			= $el;
		this.map				;
		this.mapStyles			;
		this.center				;
		
		this.color_red			= '#e3002b';
		this.color_blue			= '#2D7ABD';
		this.color_grey_light	= '#eeebe6';
		this.color_bg			= this.color_grey_light;
		this.color_marker		= this.color_red;
	};
	mapView.prototype = {
		constructor: mapView,
	
		initView: function(){
		},
		initPlugins: function(){
			
			this.mapStyles = [
				{
					"featureType": "all","elementType": "labels.text.fill",
					"stylers": [{"color": this.color_bg},{"lightness": "-44"}]
				},{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [{"visibility": "off"}]
				},{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [{"visibility": "off"}]
				},{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [{"color": this.color_bg},{"lightness": "-10"},{"visibility": "off"}]
				},{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [{"color": "#ffffff"},{"lightness": 17},{"weight": 1.2}]
				},{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [{"color": this.color_bg},{"lightness": "0"}]
				},{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [{"color": this.color_bg},{"lightness": 21}]
				},{
					"featureType": "road",
					"elementType": "geometry.stroke",
					"stylers": [{"visibility": "off"},{"lightness": "0"},{"saturation": "0"}]
				},{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [{"color": this.color_bg},{"lightness": "-44"},{"visibility": "on"},{"weight": "2"},{"saturation": "0"}]
				},{
					"featureType": "road.highway.controlled_access",
					"elementType": "geometry.stroke",
					"stylers": [{"color": "#ffffff"},{"lightness": 20},{"visibility": "off"}]
				},{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [{"color": "#ffffff"},{"lightness": 25},{"visibility": "off"}]
				},{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [{"color": "#ffffff"},{"lightness": 25},{"visibility": "off"}]
				},{
					"featureType": "road.local",
					"elementType": "geometry.stroke",
					"stylers": [{"visibility": "on"},{"saturation": "0"},{"color": this.color_bg},{"lightness": "38"}]
				},{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [{"color": this.color_bg},{"lightness": 19},{"visibility": "on"}]
				},{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [{"color": this.color_bg},{"lightness": "-20"}]
				}];
			
			this.initMap();
		},
		initMap: function(){
			var that = this;
			
			var int = setInterval(function(){
				
				if(typeof google != 'undefined'){
					clearInterval(int);
					
					that.map = new google.maps.Map(document.getElementById('google-map'), {
						center: {lat: 47.8297184, lng: 13.0775695},
						zoom: 15,
						panControl: true,
						zoomControl: false,
						mapTypeControl: true,
						scaleControl: false,
						streetViewControl: false,
						overviewMapControl: false,
						draggable: false,
						zoomControl: false,
						scrollwheel: false,
						disableDoubleClickZoom: true,
						mapTypeControl: false,
						mapTypeControlOptions: {
							position: google.maps.ControlPosition.TOP_LEFT
						}
						//mapTypeId: google.maps.MapTypeId.ROADMAP,
						//disableDefaultUI: true
					});
					that.map.setOptions({styles: that.mapStyles});
	
					var markerShape = {
						path: 'M5.8-56.9l-5.6-0.4v0l-0.2,0l-0.2,0v0l-5.6,0.4l-15.7,12.8l0.8,15.7L-0.3-0.5c0.1,0,0.1,0.1,0.1,0.2V0c0.1-0.1,0.3-0.1,0.4,0v-0.3c0-0.1,0-0.1,0.1-0.2l20.4-27.9l0.8-15.7L5.8-56.9z M10.6-30.4c-0.4,0.5-1,1.1-1.9,2c-0.3,0.2-0.8,0.7-1.7,1.5c-0.7,0.6-1.2,1-1.6,1.4c-0.9,0.7-1.8,1.5-2.9,2.4c-0.9,0.7-1.6,1.2-2.2,1.5c-0.9-0.4-1.6-0.8-2.2-1.2c-0.5-0.3-1-0.7-1.7-1.2c-1.5-1.2-2.7-2.3-3.7-3.5c-1-1.1-1.8-2.4-2.6-3.7c-0.8-1.3-1.3-2.6-1.6-3.6c0.3-0.5,0.7-1.1,1.2-1.6c0.2-0.3,0.6-0.6,1.1-1.1c0.3-0.3,0.8-0.7,1.4-1.3c0.4-0.4,0.9-0.8,1.4-1.2l0.2-0.1c0.2-0.2,0.5-0.4,1-0.8l1.5-1.2c0.9-0.8,1.7-1.4,2.4-1.8c0.3-0.2,0.6-0.4,1.1-0.6c0.6,0.3,1.3,0.7,2.1,1.2c0.8,0.6,1.6,1.2,2.4,1.9c0.7,0.7,1.5,1.4,2.2,2.3c1.2,1.4,2.2,2.9,3.1,4.5c0.8,1.4,1.3,2.7,1.6,3.9C10.9-30.8,10.7-30.6,10.6-30.4',
						fillColor: that.color_marker,
						fillOpacity: 1.0,
						scale: 1,
						strokeColor: that.color_marker,
						strokeWeight: 0
					};
	
					var marker = new google.maps.Marker({
						position: that.map.getCenter(),
						icon: markerShape,
						map: that.map
					});
				}
			}, 1000);
		},
		initListeners: function(){
			//$('.event__more, .event__close', this.$events).on('click', this.onClick.bind(this));
			var that = this, center;
			
			/*google.maps.on('idle', function(e){
				center = that.map.getCenter();
			});*/
			/*google.maps.event.addDomListener(that.map, 'idle', function() {
				center = that.map.getCenter();
			});*/
			/*google.maps.event.addDomListener(window, 'resize', function() {
				that.map.setCenter(center);
			});*/
			//this.map.bind('idle', this.getCenter.bind(this));
			$(window).bind('resize', this.onWindowResize.bind(this));
		},
		getCenter: function(e){
			this.center = that.map.getCenter();
		},
		onWindowResize: function(e){
			if(this.map){
				var center = this.map.getCenter();
				google.maps.event.trigger(this.map, "resize");
				this.map.setCenter(center);
			}
		},
		onClick: function(e){
			if($(e.target).hasClass('event__more')){
				//this.expand($(e.target).parent().parent());
			}else{
				//this.collapse($(e.target).parent());
			}
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	
	function pressView($el) {
		this.$press			= $el;
		this.$items			= $('.body-article', this.$press);
		this.timer			;
	};
	pressView.prototype = {
		constructor: pressView,
	
		initView: function(){
		},
		initPlugins: function(){
		},
		initListeners: function(){
			$('.press__header', this.$press).on('click', this.onClick.bind(this));
		},
		onClick: function(e){
			var $item = $(e.target).parent().parent();
			
			if(!$item.hasClass('item--show')){
				this.expand($item);
			}else{
				this.collapse($item, false);
			}
		},
		expand: function($item){
			var that		= this;
			var $wrapper	= $('.press__wrapper', $item);
			var $active		= $('.item--show', this.$press);
			
			if($active.length) this.collapse($active, true);
			
			clearTimeout(this.timer);
			this.timer = setTimeout(function(){
				$wrapper.css('height', $wrapper.prop('scrollHeight')+'px');
				$item.addClass('item--show item--animate');
				clearTimeout(that.timer);
				that.timer = setTimeout(function(){
					$item.removeClass('item--animate');
					$wrapper.removeAttr('style');
				}, 500);
			},10);
		},
		collapse: function($item, $active){
			var that		= this;
			var $wrapper	= $('.press__wrapper', $item);
			
			$wrapper.css('height', $wrapper.prop('scrollHeight')+'px');
			
			if(!$active){
				clearTimeout(this.timer);
				this.timer = setTimeout(function(){
					that.collapseStart($item);
					clearTimeout(that.timer);
					that.timer = setTimeout(function(){
						that.collapseEnd($item);
					}, 500);
				}, 10);
			}else{
				setTimeout(function(){
					that.collapseStart($item);
					setTimeout(function(){
						that.collapseEnd($item);
					}, 500);
				}, 10);
			}
		},
		collapseStart: function($item){
			$item.addClass('item--animate');
			$('.press__wrapper', $item).css('height', '0px');
			$item.removeClass('item--show');
		},
		collapseEnd: function($item){
			$item.removeClass('item--animate');
			$('.press__wrapper', $item).removeAttr('style');
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function selectMobile($el) {
	    this.$el			= $el;
		this.$li			= $('li', this.$el);
		this.$a				= $('a', this.$el);
		this.$select		= $('<select></select>');
	};
	selectMobile.prototype = {
	    constructor: selectMobile,
	
	    initView: function(){
	        var that = this;
			
			// MOBILE
			$('li > a', this.$el).each(function(){
				var $a = $(this), selected = ($a.parent().hasClass('active') ? " selected" : ""), title = $a.attr('title');
				that.$select.append($('<option value="'+$a.attr('href')+'"'+selected+'>'+(title ? title : $a.text())+'</option>'))
			});
			this.$el.prepend(this.$select);
	    },
	    initPlugins: function(){
	    },
	    initListeners: function(){
	        this.$select.on('change', this.onChange.bind(this));
			this.$a.on('click', this.onClick.bind(this));
	    },
		onChange: function(e){
			var $opt = $('option:selected', $(e.target)), index = $opt.index();
			this.$li.removeClass('active').filter(':eq('+index+')').addClass('active');
			location = $opt.val();
		},
	    onClick: function(e){
	        var $target = $(e.currentTarget);
			e.preventDefault();
			this.$select.prop('selectedIndex', $target.parent().index()).change();
	    },
	    init: function(){
	        this.initView();
	        this.initListeners();
	        this.initPlugins();
	    }
	
	}
	
	function tableListView( $el ) {
		this.$el			= $el;
		this.$table			= $('table', this.$el);
		this.$tHead			= $('thead', this.$table);
		this.$tHead_th		= $('th', this.$tHead);
		this.$tBody			= $('tbody', this.$table);
		this.$tBody_tr		= $('tr', this.$tBody);
		this.$tBody_td		= $('td', this.$tBody);
	};
	tableListView.prototype = {
		constructor: tableListView,
		
		initView: function(){
			var that = this;
			
			this.$tBody_td.each(function(i){
				var $td = $(this);
				
				if(!$td.text().trim().length) $(this).addClass('td--empty');
			});
			
			//if(this.$tHead.length){
				var $tr_parent;
				
				this.$tHead_th.parent().addClass('table--head');
				
				this.$tBody_tr.each(function(i){
					var $tr = $(this), $td = $('td', $tr);
	
					$td.each(function(i){
						var $td = $(this);
						
						if(that.$tHead.length){
							var $th = that.$tHead_th.filter(':eq('+i+')'), th_text = $th.text().trim().length ? $th.text() : false;
						
							if(th_text){
								$td.prepend($('<strong class="td--copytext">'+th_text+': </strong>'));
							}
							if(i==0){
								if($td.hasClass('td--empty')){
									$td.removeClass('td--empty').html('<div class="td--copy">'+$('td:eq(0)', $tr_parent).html()+'</div>');
								}
							}
						}
						
						$td.addClass('td--'+i);
						if($td.siblings().length<1) $td.addClass('td--single');
					});
					
					$tr_parent = $tr;
				});
			//}
		},
		initPlugins: function(){
		},
		initListeners: function (){
			var that = this;
		},
		init: function(){
	        this.initView();
	        this.initListeners();
	        this.initPlugins();
		}
	
	}
	function imageSlider($el) {
		this.$el 					= $el;
		this.$image_container		= $('> div', this.$el);
		this.$image_wrapper			= $('> ul', this.$image_container);
		this.$image_items			= $('> li', this.$image_wrapper);
		this.$pagination			= $('<div class="pagination pagination"></div>');
		this.$nav					= $('<div class="nav"><span></span><span></span></div>');
		this.$prev					= $('span:eq(0)', this.$nav);
		this.$next					= $('span:eq(1)', this.$nav);
		this.$image_swiper			;
	};
	imageSlider.prototype = {
		constructor: imageSlider,
	
		initView: function(){
			var that = this;
	
			this.$image_container.addClass('swiper-container');
			this.$image_wrapper.addClass('swiper-wrapper');
			this.$image_items.addClass('swiper-slide');
			this.$image_container.append(this.$nav);
			this.$el.append(this.$pagination);
		},
		initPlugins: function(){
			var that = this;
	
			this.$image_swiper = new Swiper(this.$image_container, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$pagination,
				paginationClickable: 'true',
				prevButton: this.$prev,
				nextButton: this.$next,
				slidesPerView: 1,
				slideActiveClass: 'active',
				//autoHeight: true,
	
				onInit: function(swiper){
				},
				onSlideChangeStart: function(swiper){
				},
				onSlideChangeEnd: function(swiper){
					$(window).trigger('scroll');
				}
			});
		},
		initListeners: function(){
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	
	function navCountries($el) {
	
		this.$el 				= $el;
	
		this.$a					= $('a', this.$el);
	
		this.$countries			= $('.footer-countries');
	
		this.$nav_countries		= $('.footer-nav--countries');
	
		this.$select			= $('<select></select>');
	
		this.$h					;
	
		this.$timer				;
	
	};
	
	navCountries.prototype = {
	
		constructor: navCountries,
	
	
	
		initView: function(){
	
			var that = this;
	
			$('li a', this.$countries).each(function(){
	
				var $a = $(this);
	
				that.$select.append($('<option value="'+$a.attr('href')+'">'+$a.text()+'</option>'))
	
			});
	
			this.$nav_countries.append(this.$select);
	
		},
	
		initPlugins: function(){
	
		},
	
		initListeners: function(){
	
			this.$a.on('click', this.onClick.bind(this));
	
			this.$select.on('change', this.onChange.bind(this));
	
		},
	
		onChange: function(e){
	
			location = $('option:selected', this.$select).val();
	
		},
	
		onClick: function(e){
	
			var that = this;
	
	
	
			e.preventDefault();
	
			clearTimeout(this.$timer);
	
	
	
			if(!this.$countries.hasClass('open')){
	
				this.$countries.addClass('open');
	
	
	
				if(this.$countries.outerHeight() == 0){
	
					this.$countries.css('height','auto');
	
					/*this.$countries.css('height','0px');
	
					this.$h = this.$countries.outerHeight();
	
					this.$timer = setTimeout(function(){
	
						that.$countries.css('height', that.$h);
	
						that.$timer = setTimeout(function(){
	
							that.$countries.css('height', 'auto');
	
						}, 600);
	
					}, 0);
	
					*/
	
					var y = Math.min($('body').height()-$(window).height(), this.$countries.offset().top);
	
					//TweenMax.to(window, 0.75, {scrollTo: {y: $('body').height()-$(window).height(), autoKill: true}, ease: Cubic.easeInOut});
	
					TweenMax.to(window, 0.75, {scrollTo: {y: y, autoKill: true}, ease: Quart.easeInOut});
	
				}else{
	
					that.$countries.css('height', that.$h);
	
				}
	
			}else{
	
				this.$countries.removeClass('open');
	
				/*
	
				this.$countries.css('height', this.$countries.outerHeight());
	
				that.$timer = setTimeout(function(){
	
					that.$countries.css('height','0px');
	
				}, 0);
	
				*/
	
				TweenMax.to(window, 0.75, {scrollTo: {y: $('body').height()-$(window).height()-this.$countries.outerHeight(), autoKill: true}, ease: Quart.easeInOut, onComplete:function(){
	
					that.$countries.css('height','0px');
	
				}});
	
			}
	
		},
	
		init: function(){
	
			this.initView();
	
			this.initListeners();
	
			this.initPlugins();
	
		}
	
	}
	function footerNewsletter($el) {
		this.$el				= $el;
		this.$form				= $('.footer-newsletter__inner__form', this.$el);
		this.$input				= $('input', this.$form);
		this.$submit			= $('.submit .button', this.$form);
		this.$thanks			= $('.footer-newsletter__thanks', this.$el);
		this.$back				= $('.button', this.$thanks);
		this.sending			;
	};
	footerNewsletter.prototype = {
		constructor: footerNewsletter,
	
		initView: function(){
		},
		initPlugins: function(){
		},
		initListeners: function(){
			this.$submit.on('click', this.onClickSubmit.bind(this));
			this.$back.on('click', this.onClickBack.bind(this));
		},
		onClickSubmit: function(e){
			var $target = $(e.currentTarget);
	
			e.preventDefault();
			this.formSubmit();
		},
		onClickBack: function(e){
			e.preventDefault();
			this.$input.val('');
			this.$el.toggleClass('footer-newsletter--thanks');
		},
		formSubmit: function(){
			var that = this;
			var vars = $(':input', this.$form).serialize();
			var emailReg = /^([A-Za-z0-9_\-\.\'])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
			var err = !emailReg.test(this.$input.val()) ? true : false;
	
			if(!err && !this.sending){
				this.sending = true;
				jQuery.ajax({
					context: this,
					url: this.$form.data('post'),
					type: "POST",
					data: vars,
					dataType: 'json',
					cache: false,
					success: that.onResponse
				})
				.done(that.done);
			}
		},
		onResponse: function(data){
			console.log(data);
			if(data.error){
			}else if(data.success){
				this.$el.toggleClass('footer-newsletter--thanks');
			}
		},
		done: function(){
			console.log('done');
			this.sending = false;
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	
	function search($el) {
		this.$el				= $el;
		this.$body				= $('body');
		this.$nav_search		= $('.nav--search a');
		this.$close				= $('.search-input__close', this.$form);
		this.$form				= $('.search-input__form', this.$el);
		this.$header			= $('h6', this.$form);
		this.$input				= $('input', this.$form);
		this.$total				= $('.search-input__form__total', this.$form);
		this.$submit			= $('.search-input__form__submit', this.$form);
		this.$results			= $('.search-results', this.$el);
		this.$results_inner		= $('.search-results__inner', this.$results);
		this.keyTimer			;
		this.sending			;
	
		this.$result_category	= 	$('<div class="search-results__category">\
										<div class="search-results__category__header">\
											<h6><span>(10)</span> <span>Product results</span></h6>\
										</div>\
										<div class="search-results__category__list"></div>\
									</div>');
	
		this.$result_item		= 	$('<a href="./product-detail.html">\
										<div class="search-results__category__list__image">\
											<span><img data-src="./assets/web/img/placeholder/product-overview-list/oven.png"></span>\
										</div>\
										<div class="search-results__category__list__content">\
											<h5>Divide &amp; Cook oven gezs 47000 B</h5>\
											<p>The Grundig GEZST 47000 B with Divide &amp; Cook lets you cook two totally different meals – with separate temperature settings and cooking durations – at the same time. Not even their aromas mingle.</p>\
										</div>\
									</a>');
	};
	search.prototype = {
		constructor: search,
	
		initView: function(){
			var that = this;
		},
		initPlugins: function(){
		},
		initListeners: function(){
			var that = this;
	
			this.$close.on('click', this.onClickNav.bind(this));
			this.$nav_search.on('click', this.onClickNav.bind(this));
			this.$input.on('keyup', this.onKeyUp.bind(this));
			this.$submit.on('click', this.onClickSubmit.bind(this));
	
			$(window).bind('resize orientationchange',function(){
	
			});
		},
		onKeyUp: function(e){
			var that = this;
	
			if(this.$input.val().length>0){
				this.$el.addClass('search--input');
				this.$el.removeClass('search--results');
				//this.$el.removeClass('search--results-loaded');
			}else{
				this.$el.removeClass('search--input');
				this.$el.removeClass('search--results-loaded');
				this.$results_inner.empty();
			}
	
			clearTimeout(this.keyTimer);
			this.keyTimer = setTimeout(function(){
				that.searchSubmit();
			}, 500);
		},
		onClickSubmit: function(e){
			this.$input.val('');
			this.$input.trigger('keyup');
		},
		onClickNav: function(e){
			var $target = $(e.currentTarget);
			e.preventDefault();
	
			this.$body.toggleClass('search--open');
		},
		searchSubmit: function(){
			var that = this;
			var str = this.$input.val();
			var vars = $(':input', this.$form).serialize();
	
			if(!this.sending && str.length>0){
				this.sending = true;
				jQuery.ajax({
					context: this,
					url: this.$form.data('post'),
					type: "POST",
					data: vars,
					dataType: 'json',
					cache: false,
					success: that.onResponse
				})
				.done(that.done);
	
				this.$el.addClass('search--results');
			}else{
				this.$el.removeClass('search--results');
			}
		},
		onResponse: function(data){
			//console.log(data);
	
			if(data.total){
				var $categories = $('<div></div>');
				var $category, $item;
				var categories = data.categories;
				
				//console.log(data.categories);
				this.$total.text('('+data.total+')');
				this.$results_inner.empty();
	
				for(var c=0; c<categories.length; c++){
					var cat = categories[c];
					var items = cat.items;
	
					$category = this.$result_category.clone();
					$category_list = $('.search-results__category__list', $category);
					$category_head = $('h6', $category);
					$('span:eq(0)', $category_head).text('('+cat.total+')');
					$('span:eq(1)', $category_head).text(cat.title);
					//$categories.append($category);
	
					for(var i=0; i<items.length; i++){
						var item = items[i];
	
						$item = this.$result_item.clone();
						$item.attr('src', item.url);
						$('img', $item).attr('data-src', item.img);
						$('h5', $item).text(item.title);
						$('p', $item).text(item.desc);
	
						$category_list.append($item);
					}
	
					this.$results_inner.append($category);
				}
	
				$('*[data-src]', this.$results_inner).lazyLoadXT();
	
				this.$el.addClass('search--results-loaded');
			}
		},
		done: function(){
			console.log('done');
			this.sending = false;
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	function productFilter($el) {
		this.$nav 					= $el;
		this.$nav_filter			= $('.product-filter__nav', $el);
		this.$nav_sort				= $('.product-filter__sorting', $el);
		this.$nav_sort_li			= $('li', this.$nav_sort);
		this.$nav_sort_select		= $('<select name="sorting"><option>'+$('h4', this.$nav_sort).text()+'</option></select>');
		this.$form					= $('form', $el);
		this.$products				= $el.next();
		
		this.$highlights			= $('.product-filter__highlights');
		this.$highlights_swiper		= $('> li > div', this.$highlights);
		this.$highlights_wrapper	= $('> ul', this.$highlights_swiper);
		this.$highlights_items		= $('> li', this.$highlights_wrapper);
		this.$highlights_bullets	= $('<div class="pagination pagination--vertical"></div>');
	
		this.touch					= $('html.touch').length;
		this.nav_open				;
		this.productsPushTimer		;
	};
	productFilter.prototype = {
	    constructor: productFilter,
	
	    initView: function(){
			var that = this;
	
			$('li', this.$nav_sort).each(function(){
				var $li = $(this);
				that.$nav_sort_select.append($('<option value="'+$li.data('filter')+'" '+($li.hasClass('active') ? 'selected="selected"' : '')+'>'+$li.text()+'</option>'))
			});
			this.$nav_sort.append(this.$nav_sort_select);
	    },
	    initPlugins: function(){
	    	var that = this;
	    	var slidesPerView = [3,3,3];
	
			this.$highlights_swiper.addClass('swiper-container');
			this.$highlights_wrapper.addClass('swiper-wrapper');
			this.$highlights_items.addClass('swiper-slide');
			this.$highlights_swiper.append(this.$highlights_bullets);
	
			console.log('SWIPER');
	
			this.$highlights_swiper = new Swiper(this.$highlights_swiper, {
				direction: 'vertical',
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				//nextButton: this.next,
				pagination: that.$highlights_bullets,
				paginationClickable: 'true',
				//setWrapperSize: false,
				//prevButton: this.prev,
				//slideActiveClass: 'active',
				slidesPerView: slidesPerView[0],
				//slideToClickedSlide: true,
				//spaceBetween: 0,
				autoHeight: true,
	
				breakpoints: {
					740:	{slidesPerView: slidesPerView[0]},
					1200:	{slidesPerView: slidesPerView[1]},
					5000:	{slidesPerView: slidesPerView[2]}
				},
	
				onInit: function(swiper){
				},
				onSlideChangeStart: function(swiper){
				},
				onSlideChangeEnd: function(swiper){
				}
			});
	
			 $(window).bind('resize orientationchange',function(){
			 	//that.updateVisibleSlides(that.swiper);
			 });
	    },
	    initListeners: function(){
			var that = this;
			
			this.$nav_filter.on('click', this.onClick.bind(this));
			$('li', this.$nav_sort).on('click', this.onSort.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				if(that.nav_open) that.productsPush();
	        });
	
			//if(this.touch){
				$(window).bind('scroll',function(){
					if(that.nav_open){
						if(that.$products.offset().top < $(window).scrollTop()){
							that.navClose();
							//var y = $(window).scrollTop()-that.$form.outerHeight();
							//TweenMax.to(window, 0.5, {scrollTo: {y: y, autoKill: true}, delay: 0.0, ease: Quart.easeInOutSine, onComplete:function(){}});
							that.$nav.addClass('closed');
							that.$products.removeClass('pushed');
							$('.pushed-bottom', that.$products).remove();
							$(window).scrollTop(that.$products.offset().top);
						}
					}
				});
			//}
	    },
		onSort: function(e){
			this.$nav_sort_li.not($(e.target)).removeClass('active');
			$(e.target).toggleClass('active');
		},
		onClick: function(e){
			var that				= this;
			var $target				= $(e.target), $cTarget = $(e.currentTarget);
	
			if(this.$nav.hasClass('open')){
				this.navClose();
			}else{
				this.$nav.removeClass('closed').addClass('open');
				that.$products.addClass('pushed').append('<div class="pushed-bottom"></div>');
			}
			this.nav_open = this.$nav.hasClass('open');
			this.productsPush();
	    },
	    productsPush: function(){
			var that	= this;
			var p		= this.nav_open ? this.$form.outerHeight()+'px' : 0;
	
				/*this.$products.css({
					'-webkit-transform' : 'translateY(' + p + ')',
					'-moz-transform'    : 'translateY(' + p + ')',
					'-ms-transform'     : 'translateY(' + p + ')',
					'-o-transform'      : 'translateY(' + p + ')',
					'transform'         : 'translateY(' + p + ')'
				});*/
				this.$products.css({transform: 'translateY(' + p + ')'});
				$('.pushed-bottom', that.$products).css('height', p);
				
				clearTimeout(this.productsPushTimer);
	
				if(p == 0){
					this.productsPushTimer = setTimeout(function(){
						that.$products.removeAttr('style');
					}, 700);
				}
	
	    },
		navClose: function(){
			this.nav_open = this.$nav.hasClass('open');
			if(this.nav_open){
				this.$nav.removeClass('open');
				this.nav_open = false;
				this.productsPush();
			}
		},
	    init: function(){
	        this.initView();
	        this.initListeners();
	        this.initPlugins();
	    }
	
	}
	
	function productCompareQuick($el) {
		this.$quickview				= $el;
		this.$nav					= $('.nav-sub__service .compare');
		this.$inner					= $('.product-compare-quickview__inner', $el);
		this.$next					= $el.nextAll();
	
		this.touch					= $('html.touch').length;
		this.nav_open				;
		this.pushTimer				;
	};
	productCompareQuick.prototype = {
		constructor: productCompareQuick,
	
		initView: function(){
		},
		initPlugins: function(){
			
		},
		initListeners: function(){
			var that = this;
			
			this.$nav.on('click', this.onClick.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				if(that.nav_open){
					that.$next.addClass('pushed--resize');
					that.nextPush();
					clearTimeout(this.nextPushTimer);
					this.pushTimer = setTimeout(function(){
						that.$next.removeClass('pushed--resize');
					}, 0);
				}
			});
	
			//if(this.touch){
				$(window).bind('scroll',function(){
					if(that.nav_open){
						if(that.$next.offset().top < $(window).scrollTop()){
							that.navClose();
							that.$quickview.addClass('closed');
							that.$next.removeClass('pushed');
							$('.pushed-bottom', that.$next).remove();
							$(window).scrollTop(that.$next.offset().top);
						}
					}
				});
			//}
		},
		onClick: function(e){
			var that				= this;
			var $target				= $(e.target), $cTarget = $(e.currentTarget);
	
			e.preventDefault();
	
			if(this.$quickview.hasClass('open')){
				this.navClose();
			}else{
				this.$nav.addClass('active');
				this.$quickview.removeClass('closed').addClass('open');
				that.$next.addClass('pushed').append('<div class="pushed-bottom"></div>');
	
				setTimeout(function(){
					$('*[data-src]', that.$el).lazyLoadXT({visibleOnly: false, forceLoad: true, checkDuplicates:false});
					$(window).trigger('scroll');
				}, 0);
			}
			this.nav_open = this.$quickview.hasClass('open');
			this.nextPush();
		},
		nextPush: function(){
			var that	= this;
			var p		= this.nav_open ? this.$inner.outerHeight()+'px' : 0;
	
				/*this.$next.css({
					'-webkit-transform' : 'translateY(' + p + ')',
					'-moz-transform'    : 'translateY(' + p + ')',
					'-ms-transform'     : 'translateY(' + p + ')',
					'-o-transform'      : 'translateY(' + p + ')',
					'transform'         : 'translateY(' + p + ')'
				});*/
				this.$next.css({transform: 'translateY(' + p + ')'});
				//$('.pushed-bottom', that.$next).css('height', p);
				
				clearTimeout(this.nextPushTimer);
	
				if(p == 0){
					this.nextPushTimer = setTimeout(function(){
						that.$next.removeAttr('style');
					}, 700);
				}
	
		},
		navClose: function(){
			this.nav_open = this.$quickview.hasClass('open');
			if(this.nav_open){
				this.$nav.removeClass('active');
				this.$quickview.removeClass('open');
				this.nav_open = false;
				this.nextPush();
			}
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function productCompare($el) {
		this.$el 				= $el;
		this.$wrapper			= $('.product-compare-list__wrapper', this.$el);
		this.$products			= $('.product-compare-list__products', this.$el);
		this.$products_li		= $('li', this.$products);
		this.$features			= $('.product-compare-list__features', this.$el);
	
		this.cols				= $el.hasClass('items--4') ? 4 : ($el.hasClass('items--3') ? 3 : ($el.hasClass('items--2') ? 2 : 1));
		this.posX				= parseFloat(this.$wrapper.css('left'));
		this.i					= 0;
		this.pointerStartPosX	= 0;
		this.pointerStartDirX	= 0;
		this.pointerStartDirY	= 0;
		this.dirX				= 0;
		this.dirY				= 0;
		this.moving				= false;
	};
	productCompare.prototype = {
		constructor: productCompare,
	
		initView: function(){
			var that = this;
		},
		initPlugins: function(){
			var that = this;
	
			$('.product-compare-list__products').stick_in_parent({
				parent: ".site-main"
			});
			setTimeout(function(){
				that.showProducts();
			},0);
		},
		initListeners: function(){
			var that = this;
	
			this.$wrapper.on('touchstart', this.onTouchStart.bind(this));
			this.$wrapper.on('touchmove', this.onTouchMove.bind(this));
			this.$wrapper.on('touchend', this.onTouchEnd.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				that.showProducts();
			});
		},
		onTouchStart: function(e){
			var w = this.$wrapper.outerWidth();
			
			//this.posX = parseFloat(this.$wrapper.css('left'));
			this.pointerStartDirX = this.getPointerEvent(e).pageX;
			this.pointerStartDirY = this.getPointerEvent(e).pageY;
			//this.pointerStartPosX = this.pointerStartDirX-this.posX;
			this.pointerStartPosX = this.getPointerEvent(e).pageX + this.i*w/2;
		},
		onTouchMove: function(e){
			this.posX = this.getPointerEvent(e).pageX-this.pointerStartPosX;
			this.dirX = this.getPointerEvent(e).pageX-this.pointerStartDirX;
			this.dirY = this.getPointerEvent(e).pageY-this.pointerStartDirY;
			//this.$wrapper.css('left', this.posX+'px');
			var w = this.$wrapper.outerWidth();
			var p = this.posX*100/w;
	
			if($('html.until-tablet').length){
				if(Math.abs(this.dirY) < 5 && !this.$el.hasClass('dragging')){
					this.moving = true;
				}
				if(this.moving){
					this.$wrapper.css({transform: 'translateX('+p+'%)'});
				}
				this.$el.addClass('dragging');
			}
		},
		onTouchEnd: function(e){
			if(this.moving){
				this.showProducts();
			}
			this.$el.removeClass('dragging');
		},
		getPointerEvent: function(e) {
			return e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0] : e;
		},
		showProducts: function(){
			var w = this.$wrapper.outerWidth();
			var x = this.dirX;
			var p = this.posX*100 / (w/2);
			var i = Math.abs(Math.max(0, Math.min(2, Math.round(p/-100))));
	
			this.i = i;
	
			if($('html.until-tablet').length){
	
				console.log(p+'/'+i);
	
				$('li', this.$products).removeClass('active');
				$('li:eq('+i+'), li:eq('+(i+1)+')', this.$products).addClass('active');
	
				$('ul', this.$features).each(function(){
					var $ul = $(this);
					$('li', $ul).removeClass('active');
					$('li:eq('+(i+1)+'), li:eq('+(i+2)+')', $ul).addClass('active');
					//$('li:eq(0) h6', $ul).css({transform: 'translateX('+(Math.max( 0, Math.min( 200, Math.round(p/100)*-100) ) )+'%)'});
				});
	
				$('h5', this.$features).css({transform: 'translateX('+(Math.max( 0, Math.min( 100, Math.round(p/100)*-50) ) )+'%)'});
	
				this.$el.removeClass('dragging');
				this.$el.removeClass('i0 i1 i2').addClass('i'+i);
				//this.$wrapper.css('left', (Math.max( -100, Math.min( 0, Math.round(p/100)*50) ) )+'%');
				this.$wrapper.css({transform: 'translateX('+(Math.max( -100, Math.min( 0,Math.round(p/100)*50) ) )+'%)'});
	
				this.moving = false;
			}else{
				this.$wrapper.removeAttr('style');
			}
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	function productDetailHead($el) {
		this.$el 					= $el;
		this.$wrapper				= $('.product-detail-head__wrapper', this.$el);
		this.$image_container		= $('.product-detail-head__image div', this.$el);
		this.$image_wrapper			= $('ul', this.$image_container);
		this.$image_items			= $('li', this.$image_wrapper);
		this.$image_bullets			= $('<div class="pagination pagination--darker"></div>');
		this.$image_thumbs			= $('<div class="product-detail-head__thumbs"><ul></ul></div>');
		this.$image_swiper			;
	
		this.$awards				= $('.product-detail-head__awards', this.$el);
		this.$awards_button			= $('.product-detail-head__awards-button', this.$el);
		this.$awards_close			= $('.product-detail-head__awards-close', this.$awards);
	
		this.touch					= $('html.touch').length;
	};
	productDetailHead.prototype = {
		constructor: productDetailHead,
	
		initView: function(){
			var that = this, $thumbs = $('ul', this.$image_thumbs);
	
			this.$image_container.addClass('swiper-container');
			this.$image_wrapper.addClass('swiper-wrapper');
			this.$image_items.addClass('swiper-slide');
			this.$image_container.append(this.$image_bullets);
	
			this.$image_items.each(function(i){
				var $img = $('li:eq('+i+') img', that.$image_wrapper);
				$thumbs.append($('<li class="'+(i==0 ? 'active' : '')+'"><div data-bg="'+$img.data('src')+'"></div></li>'));
			});
			this.$image_thumbs.appendTo($('.product-detail-head__wrapper', this.$el));
		},
		initPlugins: function(){
			var that = this;
	
			this.$image_swiper = new Swiper(this.$image_container, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$image_bullets,
				paginationClickable: 'true',
				slidesPerView: 1,
				slideActiveClass: 'active',
				centeredSlides: true,
				//spaceBetween: 0,
				autoHeight: true,
	
				onInit: function(swiper){
					$('*[data-src]', this.$el).lazyLoadXT({visibleOnly: false, forceLoad: false, checkDuplicates:true});
				},
				onSlideChangeStart: function(swiper){
					$('li', that.$image_thumbs).removeClass('active');
					$('li:eq('+swiper.activeIndex+')', that.$image_thumbs).addClass('active');
				},
				onSlideChangeEnd: function(swiper){
					$(window).trigger('resize');
				}
			});
	
			$(".nano").nanoScroller();
		},
		onClickThumb: function(e){
			var $cTarget = $(e.currentTarget), $li = $cTarget.parent().find('li'), i = $li.index($cTarget);
	
			$li.removeClass('active');
			$cTarget.addClass('active');
			this.$image_swiper.slideTo(i);
		},
		onClickAwards: function(e){
			var $cTarget = $(e.currentTarget);
	
			if(!$cTarget.hasClass('product-detail-head') || (this.$el.hasClass('awards--show') && !$(e.target).parents('.product-detail-head').length)){
				e.stopPropagation();
				this.$el.toggleClass('awards--show');
	
				if(this.$el.hasClass('awards--show')){
					setTimeout(function(){
						$(window).trigger('resize');
						console.log('resize');
					}, 400);
				}
			}
		},
		initListeners: function(){
			$('li', this.$image_thumbs).on('click', this.onClickThumb.bind(this));
			this.$awards_button.on('click', this.onClickAwards.bind(this));
			this.$awards_close.on('click', this.onClickAwards.bind(this));
			this.$el.on('click', this.onClickAwards.bind(this));
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function productFeaturesTop($el) {
		this.$el 						= $el;
		this.$features					= $('.product-detail-features-top__content', $el);
		this.$features_container		= $('.product-detail-features-top__content__inner', this.$features);
		this.$features_wrapper			= $('> ul', this.$features_container);
		this.$features_items			= $('> li', this.$features_wrapper);
		this.$features_bullets			= $('<div class="pagination"></div>');
		this.$features_nav				= $('.product-detail-features-top__nav', this.$el)
		this.$features_swiper			;
		this.$features_direction		;
		this.$features_index			= 0;
	
		this.$images					= $('.product-detail-features-top__images', $el);
		this.$images_container			= this.$images;
		this.$images_wrapper			= $('> ul', this.$images_container);
		this.$images_items				= $('> li', this.$images_wrapper);
		this.$images_bullets			= $('<div class="pagination"></div>');
		this.$images_index				= 0;
	
		this.touch						= $('html.touch').length;
		this.window_width				= 0;
	};
	productFeaturesTop.prototype = {
		constructor: productFeaturesTop,
	
		initView: function(){
			var that = this;
	
			//this.setHeight();
			this.$images_container.addClass('swiper-container');
			this.$images_wrapper.addClass('swiper-wrapper');
			this.$images_items.addClass('swiper-slide');
			this.$images_container.append(this.$images_bullets);
	
			this.$features_container.addClass('swiper-container');
			this.$features_wrapper.addClass('swiper-wrapper');
			this.$features_items.addClass('swiper-slide');
			this.$features_container.parent().append(this.$features_bullets);
		},
		initPlugins: function(){
			this.initFeatures();
			this.initImages();
			$(window).trigger('resize');
		},
		initFeatures: function(){
			var that = this;
			this.$features_direction = Modernizr.mq('(max-width: '+breakPoints.desktop+'px)') ? 'horizontal' : 'vertical';
			this.$features.removeClass('horizontal vertical').addClass(this.$features_direction);
	
			if(this.$features_swiper){
				this.$features_swiper.destroy(false, true);
			}
	
			this.$features_swiper = new Swiper(this.$features_container, {
				direction: this.$features_direction,
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$features_bullets,
				paginationClickable: 'true',
				slidesPerView: 1,
				slideActiveClass: 'active',
				//autoHeight: true
	
				onInit: function(swiper){
					if(that.$features_index != swiper.activeIndex) {
						swiper.slideTo(that.$features_index, 0);
						that.setIcons(that.$features_index);
					}
					that.setHeight();
				},
				onSlideChangeStart: function(swiper){
					that.setIcons(swiper.activeIndex);
				},
				onSlideChangeEnd: function(swiper){
					//$(window).trigger('resize');
				}
			});
		},
		initImages: function(){
			var that = this;
			this.$images_direction = Modernizr.mq('(max-width: '+breakPoints.tablet+'px)') ? 'horizontal' : 'vertical';
			this.$images.removeClass('horizontal vertical').addClass(this.$images_direction);
			this.$images_bullets.removeClass('pagination--vertical pagination--horizontal').addClass('pagination--'+this.$images_direction);
	
			if(this.$images_swiper){
				this.$images_swiper.destroy(false, true);
			}else{
				this.$images_items.each(function(){
					$(this).data('background', $(this).data('bg'));
				});
			}
	
			this.$images_swiper = new Swiper(this.$images_container, {
				direction: this.$images_direction,
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$images_bullets,
				paginationClickable: 'true',
				slidesPerView: 1,
				slideActiveClass: 'active',
				//autoHeight: true,
	
				onInit: function(swiper){
					//that.setHeight();
					if(that.$images_index != swiper.activeIndex) {
						swiper.slideTo(that.$images_index, 0);
					}
					that.$images_items.each(function(){
						console.log($(this).data('bg'));
						if(!$(this).attr('data-bg')){
							$(this).css('background-image', 'url("'+$(this).data('bg')+'")');
							//$(this).attr('data-bg', $(this).data('bg'));
						}
					});
				},
				onSlideChangeStart: function(swiper){
					that.$images_index = swiper.activeIndex;
				},
				onSlideChangeEnd: function(swiper){
					$(window).trigger('resize');
				}
			});
		},
		setHeight: function(){
			var that = this, hMax = 0;
	
			//console.log('setHeight');
	
			//if(this.window_width != $(window).width()){
	
				var features_direction = Modernizr.mq('(max-width: '+breakPoints.desktop+'px)') ? 'horizontal' : 'vertical';
				var images_direction = Modernizr.mq('(max-width: '+breakPoints.tablet+'px)') ? 'horizontal' : 'vertical';
	
				if(this.$features_direction != features_direction){
					this.initFeatures();
				}
				if(this.$images_direction != images_direction){
					this.initImages();
				}
				
				if(this.$features_direction == 'vertical'){
					//$('.mobile-debugger').text('');
					//this.$features_wrapper.removeAttr('style');
					this.$features_items.removeClass('swiper-slide').removeAttr('style').each(function(){
						hMax = Math.max($(this).prop('scrollHeight'), hMax);
						//$('.mobile-debugger').text($('.mobile-debugger').text()+','+hMax);
					});
					//this.$features_items.css('height', hMax+'px');
					this.$features_wrapper.css('height', hMax+'px');
					this.$features_items.addClass('swiper-slide');
				}
	
				hMax = this.$el.outerHeight();
	
				if(images_direction == 'horizontal'){
					this.$images_container.css('height', ((this.$images_container.outerWidth()*3)/4)+'px');
					this.$images_items.css('height', '100%');
					this.$images_wrapper.css('height', '100%');
				}else{
					this.$images_container.css('height', hMax+'px');
					this.$images_items.css('height', hMax+'px');
					this.$images_wrapper.css('height', hMax+'px');
				}
	
			//}
	
			this.window_width = $(window).width();
		},
		setIcons: function(i){
			this.$features_index = i;
			$('li', this.$features_nav).removeClass('active');
			$('li:eq('+i+')', this.$features_nav).addClass('active');
		},
		onClickNav: function(e){
			var $cTarget = $(e.currentTarget), $li = $cTarget.parent().find('li'), i = $li.index($cTarget);
			this.$features_swiper.slideTo(i);
		},
		initListeners: function(){
			var that = this;
	
			$('li', this.$features_nav).on('click', this.onClickNav.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				that.setHeight();
				that.$features_swiper.update(true);
			});
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function productSpecs($el) {
		this.$el 					= $el;
		this.$details_container		= $('.product-detail-specifications__details-section', this.$el);
		this.$details_wrapper		= $('> div', this.$details_container);
		this.$details_headlines		= $('> h6', this.$details_wrapper);
		this.$details_items			= $('> ul', this.$details_wrapper);
		this.$details_bullets		= $('<div class="pagination pagination"></div>');
		this.$details_nav			= $('<ul class="product-detail-specifications__details-nav"></ul>')
		this.$details_swiper		;
	
		this.touch					= $('html.touch').length;
	};
	productSpecs.prototype = {
		constructor: productSpecs,
	
		initView: function(){
			var that = this;
	
			this.$details_container.addClass('swiper-container');
			this.$details_wrapper.addClass('swiper-wrapper');
			this.$details_items.addClass('swiper-slide');
			//this.$details_container.append(this.$details_bullets);
	
			this.$details_headlines.each(function(i){
				that.$details_nav.append('<li class="'+(i==0 ? 'active' : '')+'">'+$(this).text()+'</li>');
			});
	
			this.$details_nav.prependTo(this.$details_container);
		},
		initPlugins: function(){
			var that = this;
	
			this.$details_swiper = new Swiper(this.$details_container, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				//pagination: this.$details_bullets,
				//paginationClickable: 'true',
				slidesPerView: 1,
				slideActiveClass: 'active',
				//autoHeight: true,
	
				onInit: function(swiper){
				},
				onSlideChangeStart: function(swiper){
				},
				onSlideChangeEnd: function(swiper){
				}
			});
		},
		onClickNav: function(e){
			var $cTarget = $(e.currentTarget), $li = $cTarget.parent().find('li'), i = $li.index($cTarget);
	
			$li.removeClass('active');
			$cTarget.addClass('active');
			this.$details_swiper.slideTo(i);
		},
		initListeners: function(){
			$('li', this.$details_nav).on('click', this.onClickNav.bind(this));
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function overlayInline($el) {
		this.$el 					= $el;
		this.$btn					= $('*[href="#'+this.$el.attr('id')+'"]');
		this.$hero					= this.$btn.parents('.hero');
		this.$hero_image			= $('.hero__image', this.$hero);
		this.$teaser				= this.$btn.parents('.teaser');
		this.$teaser_image			= $('.teaser__image-container', this.$teaser);
		this.$teaser_content		= $('.teaser__content', this.$teaser);
		this.$teaser_content_inner	= $('.teaser__content__inner', this.$teaser_content);
		this.$overlay_hero			= $('.hero', this.$el);
		this.$close					= $('.overlay-inline__body__close', this.$el);
		this.touch					= $('html.touch').length;
		this.timer					;
	};
	overlayInline.prototype = {
		constructor: overlayInline,
	
		initView: function(){
			if(this.$hero_image.length){
				console.log(this.$hero_image);
				console.log(this.$hero_image.data('bg'));
				$('<div class="hero__image hero__image--foreground hero__image--hidden" data-bg="'+this.$hero_image.data('bg')+'"></div>').insertAfter(this.$hero_image);
				this.$hero_image_foreground = $('.hero__image--foreground', this.$hero);
			}else{
				//this.$el.css({transform: 'translateY(-'+this.$teaser.outerHeight()+'px) translateX(100%)'});
				//this.$teaser_content.css('height', this.$teaser_content.outerHeight()+'px');
			}
		},
		initPlugins: function(){
		},
		onClickBtn: function(e){
			e.preventDefault();
			this.overlayOpen();
		},
		onClickClose: function(e){
			e.preventDefault();
			//this.overlayClose();
			this.overlayOpen();
		},
		overlayOpen: function(){
			var that = this;
	
			if(this.$hero_image.length){
				this.$el.toggleClass('overlay-inline--show-hero');
				this.$hero_image_foreground.toggleClass('hero__image--hidden');
				this.$hero.toggleClass('overlay--show');
				//this.$el.toggleClass('overlay-inline--show-hero');
				this.$hero_image.toggleClass('hero__image--background');
				//this.$el.css('height', that.$el.prop('scrollHeight')+'px');
			}else{
				//this.$teaser.css('height', '0px');
				//that.$teaser_image.css('height', that.$teaser_image.outerHeight()+'px');
				this.$teaser.toggleClass('overlay--show');
				//this.$el.css('height', this.$teaser_image.outerHeight()+'px');
				//console.log(that.$teaser_content);
				//console.log(that.$teaser_content.prop('scrollHeight'));
				
				this.$el.toggleClass('overlay-inline--show-hero');
				//this.$el.toggleClass('overlay-inline--show-teaser');
	
				if(this.$el.hasClass('overlay-inline--show-teaser')){
					this.teaserPull();
					this.$el.css('height', ((this.$overlay_hero.length && !(this.$overlay_hero.css('display')=='none')) ? this.$overlay_hero.outerHeight() : that.$el.prop('scrollHeight'))+'px');
	
					this.$el.css('height', that.$el.prop('scrollHeight')+'px');
				}
	
				TweenMax.to(window, 0.75, {scrollTo: {y: that.$teaser_content.offset().top-$('.nav-sub').outerHeight(), autoKill: true}, ease: Cubic.easeInOut, onComplete:function(){
					//$(window).trigger('resize');
					//$(document.body).trigger("sticky_kit:recalc");
					$('.nav-sub').fixTo('refresh');
				}});
			}
	
			this.$el.toggleClass('overlay-inline--show');
	
			if(this.$el.hasClass('overlay-inline--show')){
				//$('html').addClass('overlay-inline--show');
	
				clearTimeout(this.timer);
				this.timer = setTimeout(function(){
					//that.$teaser.css('height', '0px');
					that.$el.addClass('overlay-inline--open');
					that.$el.css('height', that.$el.prop('scrollHeight'));
	
					//$('.hero__image--foreground', that.$overlay_hero).removeClass('hero__image--hidden');
	
					$('.nav-sub').fixTo('refresh');
					$(window).trigger('resize');
					that.timer = setTimeout(function(){
						$('.hero__image--foreground', that.$overlay_hero).removeClass('hero__image--hidden');
						that.timer = setTimeout(function(){
							that.$el.addClass('overlay-inline--opened');
							that.$el.css('height', 'auto !important');
						}, 500);
					}, 250);
				}, this.$hero.length ? 500 : 400);
			}else{
				that.$el.removeClass('overlay-inline--opened');
				if(this.$hero_image.length){
				}else{
					//this.$teaser.css('height', this.$teaser.prop('scrollHeight')+'px');
					$('.hero__image--foreground', that.$overlay_hero).addClass('hero__image--hidden');
				}
				that.$el.css('height', that.$el.outerHeight()+'px');
	
				clearTimeout(this.timer);
				this.timer = setTimeout(function(){
					//that.$el.css('height', this.$overlay_hero.outerHeight()+'px');
					that.$el.removeAttr('style');
	
					that.timer = setTimeout(function(){
						that.timer = setTimeout(function(){
							that.$el.removeClass('overlay-inline--open overlay-inline--show');
							that.$el.removeAttr('style');
						},500);
					}, 500);
				}, 10);
			}
		},
		overlayClose: function(){
	
		},
		teaserPull: function(){
			//this.$el.css({marginTop: '-'+(this.$teaser.outerHeight()+1)+'px'});
			this.$el.css('margin-top', '-'+(Math.max(this.$teaser_content.outerHeight(), this.$teaser_image.outerHeight())+1)+'px');
		},
		initListeners: function(){
			var that = this;
	
			this.$btn.on('click', this.onClickBtn.bind(this));
			this.$close.on('click', this.onClickClose.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				if(that.$el.hasClass('overlay-inline--show')){
					if(!that.$hero_image.length){
						that.$el.addClass('overlay-inline--resize');
						that.teaserPull();
						that.$el.removeClass('overlay-inline--resize');
					}
					//that.$el.css('height', that.$el.prop('scrollHeight'));
					//that.$el.css('height','auto');
				}
			});
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function catalogueForm($el) {
		this.$el 				= $el;
		this.$buttonOpen		= $('.catalogue__button a', $el);
		this.$buttonClose		= $('.catalogue__request__inner__close', $el);
		this.$popup				= $('.catalogue__request', $el);
		this.$wrapper			= $el.parent();
		this.$inner				= $('.catalogue__request__inner', $el);
		this.$h					;
		this.$timer				;
	};
	catalogueForm.prototype = {
		constructor: catalogueForm,
	
		initView: function(){
		},
		initPlugins: function(){
		},
		initListeners: function(){
			var that = this;
			
			this.$buttonOpen.on('click', this.onClick.bind(this));
			this.$buttonClose.on('click', this.onClick.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				if(that.$popup.hasClass('open')){
					that.$wrapper.css('min-height', that.$inner.outerHeight());
				}
			});
		},
		onClick: function(e){
			var that = this, $target = $(e.target);
	
			e.preventDefault();
			console.log(this.$inner);
			this.$popup.toggleClass('open');
			clearTimeout(this.$timer);
	
			if(this.$popup.hasClass('open')){
				this.$wrapper.css('min-height', this.$inner.outerHeight());
			}else{
				this.$wrapper.css('min-height', this.$el.outerHeight());
				this.$timer = setTimeout(function(){
					that.$wrapper.css('min-height', '0px');
				}, 1000);
			}
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	function carousel($el) {
		this.element = $el;
		this.swiper = $el.find('.js-carousel-swiper');
		this.swiperWrapper = $el.find('.js-carousel-swiper-wrapper');
		this.items = $el.find('.js-carousel-item');
		this.bulletContainer = $el.find('.js-carousel-bullet-container');
		this.prev = $el.find('.js-carousel-prev');
		this.next = $el.find('.js-carousel-next');
		this.slidesPerView = this.element.hasClass('news-and-updates') ? [1,2,3] : [1,1,1];
	}
	
	carousel.prototype = {
		constructor: carousel,
	
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		},
		initView: function(){},
		initPlugins: function(){
			var context = this;
	
			this.swiper.addClass('swiper-container');
			this.swiperWrapper.addClass('swiper-wrapper');
			this.items.addClass('swiper-slide');
	
			this.swiper = new Swiper(this.swiper, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				nextButton: this.next,
				pagination: this.bulletContainer,
				paginationClickable: 'true',
				prevButton: this.prev,
				slideActiveClass: 'active',
				slidesPerView: this.slidesPerView[0],
				slideToClickedSlide: true,
				spaceBetween: 0,
				autoHeight: true,
	
				breakpoints: {
					740:	{slidesPerView: context.slidesPerView[0]},
					1200:	{slidesPerView: context.slidesPerView[1]},
					5000:	{slidesPerView: context.slidesPerView[2]}
				},
	
				onInit: function(swiper){
					context.updateVisibleSlides(swiper);
				},
				onSlideChangeStart: function(swiper){
					context.updateVisibleSlides(swiper);
				},
				onSlideChangeEnd: function(swiper){
					//$('*[data-bg]', context).lazyLoadXT({checkDuplicates:false});
					$(window).trigger('resize');
				}
			});
	
			 $(window).bind('resize orientationchange',function(){
			 	context.updateVisibleSlides(context.swiper);
			 });
		},
		initListeners: function(){},
		updateVisibleSlides: function(swiper){
			var slidesPerView = this.slidesPerView[0];
			//if(Modernizr.mq('(min-width: '+breakPoints.tablet+'px)')) slidesPerView = this.slidesPerView[1];
			//if(Modernizr.mq('(min-width: '+breakPoints.wide+'px)')) slidesPerView = this.slidesPerView[2];
			if($(window).width() >= breakPoints.tablet) slidesPerView = this.slidesPerView[1];
			if($(window).width() >= breakPoints.wide) slidesPerView = this.slidesPerView[2];
	
			var context = this,
				visibleItems = this.items.filter(function(index){
					return index >= swiper.activeIndex && index < swiper.activeIndex + slidesPerView;
				}),
				hiddenItems = this.items.not(visibleItems);
	
			visibleItems.addClass('visible');
			hiddenItems.removeClass('visible');
	
			hiddenItems.find('.js-yt-video').trigger('pause');
		}
	};
	
	function carouselList($el) {
		this.$el 					= $el;
		this.$list_container		= this.$el;
		this.$list_wrapper			= $('> ul', this.$list_container);
		this.$list_items			= $('> li', this.$list_wrapper);
		this.$list_bullets			= $('<div class="pagination pagination"></div>');
		this.$list_swiper			;
	
		this.touch					= $('html.touch').length;
		this.slidesResponsive		= $el.hasClass('product-detail-features__list') ? [1,2] : [1,2];
	};
	carouselList.prototype = {
		constructor: carouselList,
	
		initView: function(){
			this.$list_container.addClass('swiper-container');
			this.$list_wrapper.addClass('swiper-wrapper');
			this.$list_items.addClass('swiper-slide');
			this.$list_container.append(this.$list_bullets);
		},
		initPlugins: function(){
			var that = this;
			var swiperVars = this.swiperVars();
	
			this.$list_swiper = new Swiper(this.$list_container, {
				bulletActiveClass: 'active',
				bulletClass: 'bullet',
				buttonDisabledClass: 'disabled',
				pagination: this.$list_bullets,
				paginationClickable: 'true',
				slidesPerView: swiperVars.slidesPerView,
				slidesPerColumn: swiperVars.slidesPerColumn,
				//slidesPerColumnFill: 'row',
				slideActiveClass: 'active',
				slideToClickedSlide: true,
				//spaceBetween: 0,
				autoHeight: true,
	
				onInit: function(swiper){
					$('*[data-src]', this.$el).lazyLoadXT({visibleOnly: false, forceLoad: false, checkDuplicates:true});
				},
				onSlideChangeStart: function(swiper){
					that.updateVisibleSlides();
				},
				onSlideChangeEnd: function(swiper){
					$(window).trigger('resize');
				}
			});
		},
		initListeners: function(){
			var that = this;
	
			 $(window).bind('resize orientationchange', function(){
			 	var swiperVars = that.swiperVars();
			 	if(that.$list_wrapper.hasClass('swiper-wrapper')){
				 	that.$list_swiper.params.slidesPerView = swiperVars.slidesPerView;
				 	that.$list_swiper.params.slidesPerColumn = swiperVars.slidesPerColumn;
				 	that.$list_swiper.onResize();
				 	that.updateVisibleSlides();
				}
			 	if(swiperVars.slidesPerColumn < 2 && !that.$list_wrapper.hasClass('swiper-wrapper')){
			 		that.initView();
			 		that.initPlugins();
			 	}else if(swiperVars.slidesPerColumn > 1 && that.$list_wrapper.hasClass('swiper-wrapper')){
			 		that.swiperRemove();
			 	}
			 });
		},
		swiperVars: function(){
			this.slidesPerView = Modernizr.mq('(max-width: '+breakPoints.mobileLandscape+'px)') ? this.slidesResponsive[0] : (this.slidesResponsive[1]);
			//this.slidesPerColumn = Math.ceil(this.$list_items.length/this.slidesPerView);
			this.slidesPerColumn = Modernizr.mq('(min-width: '+breakPoints.desktop+'px)') ? Math.ceil(this.$list_items.length/this.slidesPerView) : 1;
			return this;
		},
		swiperRemove: function(){
			this.$list_container.removeClass('swiper-container');
			this.$list_wrapper.removeClass('swiper-wrapper');
			this.$list_items.removeClass('swiper-slide');
			this.$list_items.removeClass('slide--hidden');
			$('.pagination', this.$list_container).remove();
			this.$list_swiper.destroy(false, true);
		},
		updateVisibleSlides: function(swiper){
			var that = this;
			var slidesPerView = this.swiperVars().slidesPerView;
			var visibleItems = this.$list_items.filter(function(index){
				return index >= that.$list_swiper.activeIndex && index < that.$list_swiper.activeIndex + slidesPerView;
			});
	
			console.log(that.$list_swiper.activeIndex+' '+slidesPerView);
	
			this.$list_items.not(visibleItems).addClass('slide--hidden');
			visibleItems.removeClass('slide--hidden');
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	
	}
	
	function matchHeight($el) {
		this.element = $el;
	};
	matchHeight.prototype = {
		constructor: matchHeight,
	
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		},
		initView: function(){},
		initPlugins: function(){
			var context = this;
	
			console.log(this.element);
	
			this.element.matchHeight();
		},
		initListeners: function(){}
	};
	
	function heroSlider($el) {
		this.element = $el;
		this.swiperWrapper = $el.find('.js-hero-slider-wrapper');
		this.items = $el.find('.js-hero-slider-item');
		this.bulletContainer = $el.find('.js-hero-slider-bullet-container');
	}
	
	heroSlider.prototype = {
		constructor: heroSlider,
	
		init: function(){
			this.initView();
			this.initPlugins();
			this.initListeners();
		},
		initView: function(){},
		initPlugins: function(){
			var context = this;
	
			this.element.addClass('swiper-container');
			this.swiperWrapper.addClass('swiper-wrapper');
			this.items.addClass('swiper-slide');
	
			// mobile
			enquire.register('(max-width: 739px', {
				match: function(){
					if(typeof swiper !== 'undefined')
						swiper.destroy(true, true);
	
					context.swiper = new Swiper(context.element, {
						bulletActiveClass: 'active',
						bulletClass: 'bullet',
						buttonDisabledClass: 'disabled',
						direction: 'horizontal',
						pagination: context.bulletContainer,
						paginationClickable: 'true',
						spaceBetween: 0
					});
				}
			});
	
			// tablet, desktop, etc
			enquire.register('(min-width: 740px', {
				match: function(){
					if(typeof swiper !== 'undefined')
						swiper.destroy(true, true);
	
					context.swiper = new Swiper(context.element, {
						bulletActiveClass: 'active',
						bulletClass: 'bullet',
						buttonDisabledClass: 'disabled',
						direction: 'vertical',
						pagination: context.bulletContainer,
						paginationClickable: 'true',
						parallax: true,
						spaceBetween: 0,
						speed: 700
					});
	
					context.updateParallax();
					$(window).on('resize.heroSlider', function(){
						context.updateParallax();
					});
				},
				unmatch: function(){
					$(window).off('resize.heroSlider');
				}
			});
		},
		initListeners: function(){},
		updateParallax: function(){
			var height = this.element.outerHeight();
	
			this.element.find('.js-hero-slider-image-foreground').attr('data-swiper-parallax', height*0.9);
			this.element.find('.js-hero-slider-image-background').attr('data-swiper-parallax', height*0.8);
			this.element.find('.js-hero-slider-content').attr('data-swiper-parallax', height*0.7);
		}
	};
	
	function career($el) {
		this.$el				= $el;
		this.$nav				= $('.career__nav', this.$el);
		this.$li				= $('li', this.$nav);
		this.$a					= $('a', this.$li);
		this.$select			= $('<select></select>');
		this.$content			= $('.career__content', this.$content);
		this.$categories		= $('.career__categories', this.$content);
		this.$category			= $('.career__category', this.$content);
		this.$category_active	= $('.career__category:eq(0)', this.$categories);
	};
	career.prototype = {
		constructor: career,
	
		initView: function(){
			var that = this;
			
			if(!$('li.active', this.$nav).length) $('li:eq(0)', this.$nav).addClass('selected');
	
			$('li', this.$nav).each(function(){
				var $li = $(this), $a = $('> a', $li);
				that.$select.append($('<option value="'+$a.attr('href')+'" '+($li.hasClass('active') ? 'selected="selected"' : '')+'>'+$a.text()+'</option>'));
	
				that.$categories.addClass('swiper');
				that.$content.css('height', that.$category_active.outerHeight());
			});
			this.$nav.append(this.$select);
	
			this.setHeight();
		},
		initPlugins: function(){
		},
		initListeners: function(){
			var that = this;
	
			this.$a.on('click', this.onClickNav.bind(this));
			this.$select.on('change', this.onChange.bind(this));
	
			$(window).bind('resize orientationchange',function(){
				that.$content.addClass('resize');
				that.setHeight();
				setTimeout(function(){
					that.$content.removeClass('resize');
				}, 0);
			});
		},
		onChange: function(e){
			var $option = $('option:selected', this.$select), index = $option.index(), href = $option.val();
	
			this.$li.removeClass('active selected').filter(':eq('+index+')').addClass('active');
			this.setLink(href);
		},
		setLink: function(href){
			var that = this, $category = $(href, this.$categories);
	
			this.$category_active = $category;
			this.$category.addClass('hidden');
			this.$category_active.removeClass('hidden');
			this.setHeight();
	
			setTimeout(function(){
				that.$category.removeClass('hidden');
			}, 1000);
		},
		onClickNav: function(e){
			var $target = $(e.currentTarget), href = $target.attr('href');
	
			this.$li.removeClass('active');
			$target.parent().addClass('active');
	
			if(href.indexOf('#') >= 0){
				e.stopPropagation();
				e.preventDefault();
				this.setLink(href);
			}
		},
		setHeight: function(){
			this.$categories.css({transform: 'translateY('+(this.$category_active.position().top*-1)+'px)'});
			this.$content.css('height', this.$category_active.outerHeight()+'px');
		},
		init: function(){
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	}
	function ytVideo( element ) {
		this.element = element;
		this.preview = element.find('.js-yt-video-preview');
		this.trigger = element.find('.js-yt-video-trigger');
		this.container = element.find('.js-yt-video-container');
	}
	
	ytVideo.prototype = {
		constructor: ytVideo,
	
		init: function(){
			$.ytVideoCounter = $.ytVideoCounter || 0;
			this.counterIndex = ++$.ytVideoCounter;
			this.initHandler();
		},
	
		initHandler: function(){
			var context = this,
				videoContainerSelector = '.element__video';
	
			this.trigger.on('click.yt-video', function(e){
				e.preventDefault();
	
				var videoId = context.element.attr('data-video-id');
	
				context.container.html('<iframe id="player'+context.counterIndex+'" src="https://www.youtube.com/embed/'+videoId+'?color=white&showinfo=0&autoplay=1&enablejsapi=1&rel=0" frameborder="0" allowfullscreen></iframe>');
	
				if(typeof YT !== 'undefined')
					context.player = new YT.Player('player'+context.counterIndex, {});
	
				context.preview.velocity({
					opacity: 0
				}, {
					display: 'none'
				});
			});
	
			this.element.on('pause.yt-video', function(e){
				context.pause();
			});
	
			$(document).on('pause-yt-videos.yt-video', function(e){
				context.pause();
			});
		},
	
		pause: function(){
			if(this.player)
				this.player.pauseVideo();
		}
	};
	
	(function($) {
	
		var SelectionSharer = function(options) {
	
			var self = this;
	
			options = options || {};
			if(typeof options == 'string')
				options = { elements: options };
	
			this.sel = null;
			this.textSelection='';
			this.htmlSelection='';
	
			this.getSelectionText = function(sel) {
					var html = "", text = "";
					var sel = sel || window.getSelection();
					if (sel.rangeCount) {
							var container = document.createElement("div");
							for (var i = 0, len = sel.rangeCount; i < len; ++i) {
									container.appendChild(sel.getRangeAt(i).cloneContents());
							}
							text = container.textContent;
							html = container.innerHTML;
					}
					self.textSelection = text;
					self.htmlSelection = html || text;
					return text;
			};
	
			this.show = function(e) {
				window.setTimeout(function() {
					var sel = window.getSelection(),
						selection = self.getSelectionText(sel);
	
					if(!sel.isCollapsed && selection && selection.length>0) {
						var range = sel.getRangeAt(0),
							rect = range.getBoundingClientRect(),
							topOffset = rect.top - 8,
							top = topOffset + window.scrollY - self.$popover.height(),
							left = rect.left + rect.width/2 - self.$popover.outerWidth()/2;
	
						self.$popover.css("top", top+10).css("left", left);
	
						window.setTimeout(function() {
							self.$popover.show().addClass("anim").css("top", top);
						}, 0);
					} else {
						self.hide();
					}
				}, 10);
			};
	
			this.hide = function(e) {
				self.$popover.removeClass('anim').hide();
			};
	
			this.smart_truncate = function(str, n){
					if (!str || !str.length) return str;
					var toLong = str.length>n,
							s_ = toLong ? str.substr(0,n-1) : str;
					s_ = toLong ? s_.substr(0,s_.lastIndexOf(' ')) : s_;
					return  toLong ? s_ +'...' : s_;
			};
	
			this.shareTwitter = function(e) {
				e.preventDefault();
	
				var text = '"'+self.smart_truncate(self.textSelection.trim(), 114)+'"';
	
				share.prototype.shareTwitter(text);
			};
	
			this.shareFacebook = function(e) {
				e.preventDefault();
	
				var text = self.htmlSelection.replace(/<p[^>]*>/ig,'\n').replace(/<\/p>|  /ig,'').trim();
	
				share.prototype.shareFacebook(text);
			};
	
			this.render = function() {
				var popoverHTML =  '<div class="selection-sharer js-selection-sharer" style="position:absolute;">'
					 + '  <div class="selection-sharer__text">share</div>'
					 + '  <button class="selection-sharer__action selection-sharer__action--facebook js-selection-sharer-facebook"><i class="icon icon--social-facebook"></i></button>'
					 + '  <button class="selection-sharer__action selection-sharer__action--twitter js-selection-sharer-twitter"><i class="icon icon--social-twitter"></i></button>'
					 + '</div>';
	
				self.$popover = $(popoverHTML);
				self.$popover.find('.js-selection-sharer-twitter').click(self.shareTwitter);
				self.$popover.find('.js-selection-sharer-facebook').click(self.shareFacebook);
	
				$('body').append(self.$popover);
			};
	
			this.setElements = function(elements) {
				if(typeof elements == 'string')
					elements = $(elements);
	
				self.$elements = elements instanceof $ ? elements : $(elements);
	
				self.$elements.on('mouseup.selection-sharer', self.show);
	
				$(document).on('keyup.selection-sharer', function(e){
					if(e.shiftKey && [37, 38, 39, 40].indexOf(e.keyCode)){
						self.show();
					}
				});
	
				$(document).on('mousedown.selection-sharer', function(e){
					var target = $(e.target);
	
					if(!target.is(self.$popover) && !target.closest(self.$popover).length){
						self.hide();
					}
				});
	
				$(window).on('load.selection-sharer resize.selection-sharer', function(){
					self.show();
				});
			};
	
			this.render();
	
			if(options.elements) {
				this.setElements(options.elements);
			}
	
		};
	
		// jQuery plugin
		// Usage: $( "p" ).selectionSharer();
		$.fn.selectionSharer = function() {
			var sharer = new SelectionSharer();
			sharer.setElements(this);
			return this;
		};
	
	})(jQuery);
	
	function share( element ) {
		this.element = element;
		this.facebookTrigger = this.element.filter('.js-share-facebook');
		this.twitterTrigger = this.element.filter('.js-share-twitter');
	}
	
	// console.log(share);
	
	share.prototype = {
		constructor: share,
	
		init: function(){
			this.initHandler();
		},
	
		initHandler: function(){
			var context = this;
	
			this.facebookTrigger.on('click.share', function(e){
				e.preventDefault();
	
				var text = $(this).data('share-text');
	
				context.shareFacebook(text);
			});
	
			this.twitterTrigger.on('click.share', function(e){
				e.preventDefault();
	
				var text = $(this).data('share-text');
	
				context.shareTwitter(text);
			});
		},
	
		shareFacebook: function(text){
			if(typeof text == 'undefined')
				text = '';
	
			var appId = $('meta[property="fb:app_id"]').attr("content") || $('meta[property="fb:app_id"]').attr("value"),
				url2share = $('meta[property="og:url"]').attr("content") || $('meta[property="og:url"]').attr("value") || window.location.href,
				url = 'https://www.facebook.com/dialog/feed?'
					+ 'app_id='+appId
					+ '&display=popup'
					+ '&caption='+encodeURIComponent(text)
					+ '&link='+encodeURIComponent(url2share)
					+ '&href='+encodeURIComponent(url2share)
					+ '&redirect_uri='+encodeURIComponent(url2share),
				w = 640,
				h=440,
				left = (screen.width/2)-(w/2),
				top = (screen.height/2)-(h/2)-100;
	
			window.open(url, "share_facebook", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
		},
	
		shareTwitter: function(text){
			if(typeof text == 'undefined')
				text = '';
	
			var url = 'http://twitter.com/intent/tweet?text='+encodeURIComponent(text)+'&url='+encodeURIComponent(window.location.href),
				w = 640, h=440,
				left = (screen.width/2)-(w/2),
				top = (screen.height/2)-(h/2)-100;
	
			window.open(url, "share_twitter", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
		}
	};
	
	function dynamicList( element ) {
		this.element = element;
		this.filterTrigger = this.element.find('.js-dynamic-list-filter');
		this.loadMoreTrigger = this.element.find('.js-dynamic-list-load-more');
		this.itemContainer = this.element.find('.js-dynamic-list-item-container');
		this.loadable = this.element.find('.js-dynamic-list-loadable');
	
		this.template = _.template(this.element.find('.js-dynamic-list-template').html());
		this.xmlRoot = this.element.data('xml-root');
		this.xmlItem = this.element.data('xml-item');
	}
	
	dynamicList.prototype = {
		itemSelector: '.js-dynamic-list-item',
		limit: 9,
		constructor: dynamicList,
	
		init: function(){
			var context = this;
	
			this.initPlugins();
			this.initHandler();
		},
	
		initPlugins: function(){
			var context = this,
				activeTrigger = this.getActiveFilterTrigger();
	
			if(activeTrigger.length){
				History.replaceState({
					state: 'dynamicListFilter',
					filterUrl: activeTrigger.attr('href')
				});
			}
	
			this.itemContainer.isotope({
				itemSelector: this.itemSelector,
				layoutMode: 'masonry',
				transitionDuration: '0.8s',
				masonry: {
					gutter: 0
				}
			});
	
			enquire.register('screen and (max-width: 739px)', {
				match: function(){
					context.mobileHiddenItems = context.itemContainer.find(context.itemSelector).slice(2);
	
					context.mobileHiddenItems.detach();
					context.itemContainer.isotope('layout');
				},
				unmatch: function(){
					if(context.mobileHiddenItems && context.mobileHiddenItems.length){
						context.itemContainer.append(context.mobileHiddenItems);
						context.itemContainer.isotope('layout');
	
						delete context.mobileHiddenItems;
					}
				}
			});
		},
	
		initHandler: function(){
			var context = this;
	
			this.itemContainer.on('layoutComplete', function(){
				$(window).trigger('scroll');
			});
	
			this.loadMoreTrigger.on('click.dynamic-list', function(e){
				e.preventDefault();
	
				context.loadMore();
			});
	
			this.filterTrigger.on('click.dynamic-list', function(e){
				e.preventDefault();
	
				var trigger = $(this);
	
				History.pushState({
					state: 'dynamicListFilter',
					filterUrl: trigger.attr('href')
				}, trigger.data('title'), trigger.attr('href'));
			});
	
			this.element.on('change', '.js-nav-sub-select', function(e){
				var select = $(this),
					trigger = context.filterTrigger.filter('[href="'+select.val()+'"]');
	
				History.pushState({
					state: 'dynamicListFilter',
					filterUrl: trigger.attr('href')
				}, trigger.data('title'), trigger.attr('href'));
			});
	
			History.Adapter.bind(window, 'statechange anchorchange', function(){
				var state = History.getState();
	
	
				if(state.data && state.data.state === 'dynamicListFilter'){
					var trigger = context.filterTrigger.filter('[href="'+state.data.filterUrl+'"]');
	
					context.filter(trigger);
				}
			});
		},
	
		getActiveFilterTrigger: function(){
			var active;
	
			if(this.filterTrigger.length){
				this.filterTrigger.each(function(){
					var trigger = $(this);
	
					if(trigger.parent().hasClass('active')){
						active = trigger;
						return false;
					}
				});
			}
	
			return active || $();
		},
	
		filter: function(trigger){
			var context = this,
				activeTrigger = this.getActiveFilterTrigger();
	
			// if(trigger.is(activeTrigger))
			// 	return;
	
			this.loadable.addClass('loading');
	
			$.ajax({
				url: trigger.data('api-url'),
				method: 'get',
				dataType: 'xml',
				data: {
					limit: this.limit,
					offset: 0
				},
				success: function(dataXml){
					var dataJson = xmlToJSON.parseXML(dataXml),
						html = context.render(dataJson),
						items = $(html);
	
					Main.initPlugins(items);
	
					context.itemContainer.find(context.itemSelector).each(function(){
						var item = $(this),
							id = item.data('id'),
							newItem = items.filter('[data-id="'+id+'"]');
	
						if(newItem.length){
							items = items.not(newItem);
							newItem.remove();
						} else {
							context.itemContainer.isotope('remove', item);
						}
					});
	
					context.itemContainer.isotope('insert', items);
					context.itemContainer.isotope('layout');
	
					activeTrigger.parent().removeClass('active');
					trigger.parent().addClass('active');
	
					setTimeout(function() {
						$(window).lazyLoadXT();
					}, 50);
	
					context.element.velocity('scroll', {
						duration: 800,
						easing: 'easeOutQuart'
					});
	
					context.loadable.removeClass('loading');
	
					// show/hide load more button
	
					if(dataJson[context.xmlRoot][0]._attr['more-items']._value){
						context.showLoadMore();
					} else {
						context.hideLoadMore();
					}
	
					// remove detached mobile items
					if(context.mobileHiddenItems && context.mobileHiddenItems.length)
						delete context.mobileHiddenItems;
				},
				error: function(){
					context.loadable.removeClass('loading');
					toastr.error(context.element.data('error-message'), context.element.data('error-title'));
				}
			});
		},
	
		render: function(data){
			var context = this,
				html = '';
	
			_.forEach(data[this.xmlRoot][0][this.xmlItem], function(item){
				html += context.template(item);
			});
	
			return html;
		},
	
		loadMore: function(){
			var context = this,
				activeTrigger = this.getActiveFilterTrigger();
	
			if(context.mobileHiddenItems && context.mobileHiddenItems.length){
				context.itemContainer
					.append(context.mobileHiddenItems)
					.isotope('layout');
	
				setTimeout(function(){
					$('*[data-bg]', context.element).lazyLoadXT({visibleOnly: false, forceLoad: true, checkDuplicates:false});
					$(window).trigger('scroll');
				}, 0);
	
				delete context.mobileHiddenItems;
				return;
			}
	
			this.loadable.addClass('loading');
			this.loadMoreTrigger.addClass('loading');
	
			$.ajax({
				url: activeTrigger.data('api-url'),
				method: 'get',
				dataType: 'xml',
				data: {
					limit: this.limit,
					offset: this.getOffset()
				},
				success: function(dataXml){
					var dataJson = xmlToJSON.parseXML(dataXml),
						html = context.render(dataJson),
						items = $(html);
	
						Main.initPlugins(items);
	
						items.each(function(){
							var item = $(this),
								id = item.data('id');
	
							if(!context.itemContainer.find(context.itemSelector).filter('[data-id="'+id+'"]').length){
								context.itemContainer
									.append(item)
									.isotope('appended', item);
							}
						});
	
						setTimeout(function() {
							$(window).lazyLoadXT();
						}, 50);
	
						context.loadable.removeClass('loading');
						context.loadMoreTrigger.removeClass('loading');
	
						if(dataJson[context.xmlRoot][0]._attr['more-items']._value){
							context.showLoadMore();
						} else {
							context.hideLoadMore();
						}
				},
				error: function(){
					context.loadable.removeClass('loading');
					context.loadMoreTrigger.removeClass('loading');
					toastr.error(context.element.data('error-message'), context.element.data('error-title'));
				}
			});
		},
	
		getOffset: function(){
			var offset = this.itemContainer.find(this.itemSelector).length - 1;
	
			if(offset < 0)
				offset = 0;
	
			return offset;
		},
	
		hideLoadMore: function(){
			this.loadMoreTrigger.velocity({
				opacity: 0
			}, {
				visibility: 'hidden'
			});
		},
	
		showLoadMore: function(){
			this.loadMoreTrigger.velocity({
				opacity: 1
			}, {
				visibility: 'visible'
			});
		}
	};
	
	function bookmark($el) {
		this.element = $el;
		this.url = this.element.data('bookmark-url');
	}
	
	bookmark.prototype = {
		constructor: bookmark,
	
		init: function(){
			this.initListeners();
		},
		initListeners: function(){
			var context = this;
	
			this.element.on('click.bookmark', function(e){
				e.preventDefault();
	
				context.element.addClass('loading');
	
				$.ajax({
					url: context.url,
					method: 'post',
					success: function(dataXml){
						var data = $(dataXml),
							success = data.find('success');
	
						if(success.text() === 'true'){
							context.element.toggleClass('active');
						} else {
							context.showErrorMessage();
						}
	
						context.element.removeClass('loading');
					},
					error: function(){
						context.showErrorMessage();
						context.element.removeClass('loading');
					}
				});
			});
		},
	
		showErrorMessage: function(){
			if(this.element.hasClass('active')){
				toastr.error(window.translation.bookmark_remove_error_text, window.translation.bookmark_remove_error_title);
			} else {
				toastr.error(window.translation.bookmark_add_error_text, window.translation.bookmark_add_error_title);
			}
		}
	};
	
	function contactSwitch($el) {
		this.element = $el;
		this.select = this.element.find('.js-contact-switch-select');
		this.contentContainer = this.element.find('.js-contact-switch-content-container');
		this.contents = this.element.find('.js-contact-switch-content');
	}
	
	contactSwitch.prototype = {
		constructor: contactSwitch,
	
		init: function(){
			this.initListeners();
		},
		initListeners: function(){
			var context = this;
	
			this.select.on('change.contactSwitch', function(e){
				context.change($(this).val());
			});
		},
		change: function(slug){
			var context = this,
				duration = 500,
				easing = 'easeOutQuart',
				oldContent = this.contents.filter('.active'),
				newContent = this.contents.filter('[data-slug="'+slug+'"]');
	
			if(!newContent.length)
				return;
	
			this.contentContainer.velocity({
				height: newContent.outerHeight()
			}, {
				duration: duration,
				complete: function(){
					context.contentContainer.css('height', '');
					oldContent.removeClass('active');
					newContent.addClass('active');
					newContent.css('visibility', '');
				}
			});
	
			oldContent.children().each(function(index, element){
				var item = $(this);
	
				item.velocity({
					opacity: 0,
					translateX: -20
				}, {
					delay: index*50,
					duration: duration,
					easing: easing
				});
			});
	
			newContent.children().each(function(index, element){
				var item = $(this);
	
				item.css('opacity', 0);
	
				item.velocity({
					opacity: [1, 0],
					translateX: [0, 20]
				}, {
					delay: index*50,
					duration: duration,
					easing: easing
				});
			});
	
			newContent.css('visibility', 'visible');
		}
	};
	
	function Main(){}
	
	Main.prototype = {
		constructor: Main,
	
		initSite: function ()  {
			$('html').each(function(){
				//new siteView($(this)).init();
			});
	
			// DEBUGGER
	
			if(location.href.indexOf('templates.')>0 || location.href.indexOf('.xip.io')>0){
				$('body').append($('<div class="mobile-debugger"></div>'));
				$('body').addClass('showDebug');
				$('.mobile-debugger').addClass('showDebug');
			}
	
			$(window).bind('resize orientationchange',function(){
				var html = $('html');
	
				//if($('html.no-touch').length || isDesktop){
					//isDesktop = true;
					if (Modernizr.mq('(max-width: '+breakPoints.desktop+'px)'))	{html.addClass('touch until-desktop').removeClass('no-touch');} else {html.removeClass('touch until-desktop').addClass('no-touch');}
					if (Modernizr.mq('(max-width: '+breakPoints.tablet+'px)'))	{html.addClass('until-tablet');} else {html.removeClass('until-tablet');}
					if (Modernizr.mq('(max-width: '+breakPoints.tabletLandscape+'px)'))	{html.addClass('until-tabletLandscape');} else {html.removeClass('until-tabletLandscape');}
					if (Modernizr.mq('(min-width: '+breakPoints.tablet+'px)'))	{html.addClass('from-tablet');} else {html.removeClass('from-tablet');}
				//}
			});
	
			// SCROLLMAGIC
	
			if(!$('html.lt-ie9').length){
				scrollController = new ScrollMagic.Controller();
				$(window).bind('resize orientationchange',function(){
					scrollController.update(true);
				});
			}
	
			// TOASTR
	
			toastr.options.closeButton = true;
			toastr.options.closeHtml = '<button class="toastr-close"><i class="icon icon--close"></i></button>';
			toastr.options.showMethod = 'toastrSlideRightIn';
			toastr.options.showDuration = 400;
			toastr.options.showEasing = 'easeOutQuart';
			toastr.options.hideDuration = 300;
	
			$.fn.toastrSlideRightIn = function(options){
				if(!this.hasClass('active')){
					this.addClass('active');
					this.velocity('transition.slideRightIn', options);
				}
			};
		},
		initPlugins: function(scope){
	
			// NAVIGATION
	
			scope.find('.nav-main').each(function(){
				new navMain($(this)).init();
			});
	
			scope.find('.nav-sub').each(function(){
				new navSub($(this)).init();
			});
	
			scope.find('.site-footer').each(function(){
				new navFooter($(this)).init();
			});
			
			// HOME
	
			scope.find('.page--home .teaser--news .teaser__img').each(function(){
				new homeFacebook($(this)).init();
			});
			scope.find('.page--home .teaser--news .teaser__wrapper').each(function(){
				new homeNews($(this)).init();
			});
			
			// EVENTS
			
	        $('.events').each(function(){
	            new eventsView($(this)).init();
	        });
			
			// PRESS
			
			$('.press').each(function(){
				new pressView($(this)).init();
			});
			
			// IMAGE SLIDER
			
	        $('.body-image-slider').each(function(){
	            new imageSlider($(this)).init();
	        });
			
			// FORMS
	
			$('input[type=radio], input[type=checkbox]').each(function(){
				new inputView($(this)).init();
			});
			
			$('input.submit').closest('.body-text').each(function(){
				new formView($(this)).init();
			});
	
			// GOOGLE MAPS
			
			$('.google-maps').each(function(){
				new mapView($(this)).init();
				window.initMap = mapView.initMap;
			});
			
			// SELECT MOBILE
			
			$('.select-mobile').each(function(){
				new selectMobile($(this)).init();
			});
			
			// TABLE LIST
			
			$('.body-table-list').each(function(){
				new tableListView($(this)).init();
			});
			
			
	
			// SEARCH
	
			scope.find('.search').each(function(){
				new search($(this)).init();
			});
	
			// CAROUSEL
	
			scope.find('.js-carousel').each(function(){
				new carousel($(this)).init();
			});
	
			// CAROUSEL LIST
	
			scope.find('.carousel-list').each(function(){
				new carouselList($(this)).init();
			});
	
	
			// MATCH HEIGHT
	
			scope.find('.js-match-height').matchHeight();
	
			// DOTDOTDOT
	
			scope.find('.js-dotdotdot').dotdotdot({
				watch: 'window'
			}).trigger('update');
	
			// SELECTION SHARER
	
			scope.find('.js-selection-sharer').selectionSharer();
	
			// SHARE
	
			scope.find('[class*="js-share-"]').each(function(){
				new share($(this)).init();
			});
	
		},
		init: function(){
			Main.initSite();
			Main.initPlugins($(document));
			$(window).trigger('resize');
		}
	};
	
	var breakPoints = {
		mobile:				320,
		mobileLandscape:	480,
		tablet:				740,
		desktopAd:			810,
		tabletLandscape:	906,
		desktop:			980,
		desktopEx:			1025,
		wide:				1200,
		full:				1300
	};
	
	var isDesktop;
	var Main = new Main();
	
	$(Main.init);
	
	


})(jQuery);

